import React, { useEffect, useState, useRef,useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faChevronDown, faChevronUp, faSortUp, faSortDown, faX, faVcard, faPlus, faPen, faMobileAndroidAlt, faPlusCircle, faSave, faTimes, faTrash, faBank ,faMapMarkerAlt,faSearch,faFilter,faList ,faSliders } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import  '../Css/Tooltip.css';
import {Loader, Spinner } from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages';
import Assignvendor from '../Components/Assignvendor';
import Search from '../Components/Search';
import useAutoScroll from '../Components/UseAutoScroll';
import { decryptData } from '../../utils/storageCrypto';

const useOutsideClick = (ref, callback) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };
  React.useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
};

const CustomDropdown = ({ options, selected, onSelect, trigger }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  useOutsideClick(dropdownRef, () => setIsOpen(false));

  const handleOptionClick = (value) => {
    onSelect(value);
    setIsOpen(false);
  };

  return (
    <div className="relative w-1/6" ref={dropdownRef}>
      {trigger}
      {isOpen && (
<div className="absolute mt-1 w-full h-40 bg-transparent border-none shadow-none z-10 flex flex-col"> 
           <div className="overflow-y-auto scrollbar-visible flex-grow">
            {options.map((option) => (
              option.value !== 'add-new' && (
                <div className='p-1'>
                  <div
                    key={option.value}
                    className="py-2 pl-1 cursor-pointer text-sm hover:bg-blue-500 hover:rounded-md  hover:text-white"
                    onClick={() => handleOptionClick(option.value)}
                  >
                    {option.icon && <FontAwesomeIcon icon={option.icon} className="" />}
                    {option.label}
                  </div>
                </div>
              )
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const ViewVendor = () => {
  const navigate = useNavigate();
  const  [vendors , setVendors] = useState ([]);
  const location = useLocation()
  const {VendorData}= location.state
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  const [showAddress, setShowAddress] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [vendorid , setVendorid] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [showOtherDetails , setShowOtherDetails] = useState(false);
  const [showContactPersons , setShowContactPersons] = useState(false);
  const [ShowBankAccountDetails, setShowBankAccountDetails] = useState(false);
  const [ VendorContactPersons , setVendorContactPersons] = useState([]);
  const [selectedContactPerson, setSelectedContactPerson] = useState(null);
  const [showVendorDetailsPopup, setVendorDetailsPopup] = useState(false);
  const [showProjectDetailsPopup, setShowProjectDetailsPopup] = useState(false);
  const [showAddContactPersonPopup, setShowAddContactPersonPopup] = useState(false);
  const [showAddBankAccountDetails, setShowAddBankAccountDetails] = useState(false);
  const [showAssignProductCategoryPopup , setShowAssignProductCategoryPopup] = useState(false);
  const [ShowEditContactPersonPopup ,setShowEditContactPersonPopup] = useState(false);
  const [ShowDeleteContactPersonPopup , setShowDeleteContactPersonPopup] = useState(false);
  const [newContactPerson, setNewContactPerson] = useState({
    name: '',    email: '',
    mobile_number: '',    designation: '',  });
    const [newBankAccount, setNewBankAccount] = useState({
      bank_name: '',    bank_branch: '',
      account_holder_name: '',    bank_IFSC: '', account_number: '' });
  const [salutation, setSalutation] = useState('');
  const [categories,setCategories] = useState([]);
  const [vendorCategories,setVendorCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState({});
  const [alreadySavedCategories, setAlreadySavedCategories] = useState({});
  const [selectedOption, setSelectedOption] = useState(null); // define selectedOption and setSelectedOption
  const [product_category_ids,setproduct_category_ids] = useState();
  const backendApiUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [errorMessages, setErrorMessages] = useState([]);
  const [retryFunction, setRetryFunction] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [vendorStatus, setVendorStatus] = useState('Deactivate');
  const RETRY_LIMIT = 3; // Maximum number of retries
const [retryCount, setRetryCount] = useState(0); // Track retry attempts
const [PurchaseOrders, setPurchaseOrders] = useState([]);
const [vendorEditErrors, setVendorEditErrors] = useState([]);
const [contactPersonErrors, setContactPersonErrors] = useState([]);
const [showApprovePopup, setShowApprovePopup] = useState(false);
const [showDisapprovePopup, setShowDisapprovePopup] = useState(false);
const [loading, setLoading] = useState(false); // Track the loading state for API calls
const [vendorApprovalStatus, setVendorApprovalStatus] = useState(null); // Track the current vendor status
// LOCATION states
const [showLocation, setShowLocation] = useState(false);
const [latitude, setLatitude] = useState('');
const [longitude, setLongitude] = useState('');
const [isLocationSaving, setIsLocationSaving] = useState(false);
const [subCategoryMap, setSubCategoryMap] = useState({});
const [movData, setMovData] = useState({ categories: [], subcategories: [] });
const [searchQuery, setSearchQuery] = useState('');  
const [searchType, setSearchType] = useState('');    
const searchTypes = ['Vendor Name', 'Company Name', 'Mobile Number'];  
const itemRefs = useRef({});
const listContainerRef = useRef(null);
const [originalLatitude, setOriginalLatitude] = useState('');
const [originalLongitude, setOriginalLongitude] = useState('');
const [showDiscountPopup, setShowDiscountPopup] = useState(false);
const [selectedCategory, setSelectedCategory] = useState("");
const [attributes, setAttributes] = useState([]);
const [deleteConfirmed, setDeleteConfirmed] = useState({
  show: false,
  sectionIndex: null,
  rowIndex: null
});
const buttonRefs = useRef({}); // ✅ Object ref for sections
const [openDropdownIndex, setOpenDropdownIndex] = useState({ 
  sectionIndex: null 
});
const [dropdownStyle, setDropdownStyle] = useState({})
const [categoryRowsMap, setCategoryRowsMap] = useState({});
const [selectedSubCategory, setSelectedSubCategory] = useState("");
const [subCategories, setSubCategories] = useState([]);
const [savedSlabs, setSavedSlabs] = useState({});
const [isDiscountLoading, setIsDiscountLoading] = useState(false);



const getDefaultRow = () => ({
  mov: "",
  discount: "",
  attributes: [],           // ✅ EMPTY
  attributeIds: [],         // ✅ EMPTY  
  open: false,
  isExisting: false         // ✅ NEW ROW
});

const [slabSections, setSlabSections] = useState([
  {
    id: Date.now(),
    rows: [getDefaultRow()]
  }
]);

// useEffect(() => {
//   const test = (e) => {
//     console.log("🌍 GLOBAL CLICK:", e.target);
//   };

//   window.addEventListener("click", test);
//   return () => window.removeEventListener("click", test);
// }, []);

useEffect(() => {
  if (openDropdownIndex === null) {
    setDropdownStyle({});
  }
}, [openDropdownIndex]);


  useEffect(() => {
    fetchVendors(VendorData);
}, [VendorData]);

useAutoScroll({
  selectedItem: selectedVendor,
  itemRefs,
  containerRef: listContainerRef,
});

useEffect(() => {
  const handleClick = () => {
    setOpenDropdownIndex(null);
  };

  window.addEventListener("click", handleClick);
  return () => window.removeEventListener("click", handleClick);
}, []);


useEffect(() => {
  if (
    selectedVendor &&
    selectedCategory &&
    selectedSubCategory &&
    slabSections.length > 0
  ) {
    setSavedSlabs(prev => ({
      ...prev,
      [selectedVendor._id]: {
        ...prev[selectedVendor._id],
        [selectedCategory]: {
          ...prev[selectedVendor._id]?.[selectedCategory],
          [selectedSubCategory]: slabSections
        }
      }
    }));
  }
}, [slabSections]); // 🔥 track changes

useEffect(() => {
  if (selectedVendor?.location) {

    const loc = typeof selectedVendor.location === "string"
      ? JSON.parse(selectedVendor.location)
      : selectedVendor.location;

    const lat = loc?.lat || '';
    const lng = loc?.lng || '';

    setLatitude(lat);
    setLongitude(lng);
    setOriginalLatitude(lat);
    setOriginalLongitude(lng);

  } else {
    setLatitude('');
    setLongitude('');
    setOriginalLatitude('');
    setOriginalLongitude('');
  }
}, [selectedVendor]);

const shouldShowSave =
  !originalLatitude ||
  !originalLongitude ||
  latitude !== originalLatitude ||
  longitude !== originalLongitude;

const filteredVendors = useMemo(() => {
  if (!searchQuery || !searchType) return vendors; 

  const q = searchQuery.toLowerCase();
  const type = searchType.toLowerCase();

  return vendors.filter(vendor => {
    switch (type) {
      case 'vendor name':
        return vendor?.name?.toLowerCase().includes(q);
      case 'company name':
        return vendor?.company_name?.toLowerCase().includes(q);
      case 'mobile number':
        return vendor?.mobile_number?.toLowerCase().includes(q);
      default:
        return true;
    }
  });
}, [vendors, searchQuery, searchType]);

const handleSearch = ({ query, type }) => {
  if (!query?.trim() || !type) return;
  setSearchQuery(query.trim());
  setSearchType(type);
};




const [rows, setRows] = useState([]);

// useEffect(() => {
//   if (openDropdownIndex?.sectionIndex !== null && buttonRefs.current[openDropdownIndex.sectionIndex]) {
//     const button = buttonRefs.current[openDropdownIndex.sectionIndex];
//     if (button) {
//       const rect = button.getBoundingClientRect();
//       setDropdownStyle({
//         top: rect.bottom + window.scrollY + 5,
//         left: rect.left + window.scrollX
//       });
//     }
//   }
// }, [openDropdownIndex, slabSections]);


const handleConfirmedDelete = async () => {
  const { sectionIndex, rowIndex } = deleteConfirmed;
  const section = slabSections[sectionIndex];
  const row = section.rows[rowIndex];

  try {
    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);

    const payload = {
      category_deletes: [{
        document_id: row.document_id,
        mov: row.mov
      }],
      subcategory_deletes: []
    };

    const res = await fetch(
      `${backendApiUrl}discount/delete-discountslabs`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-token": token
        },
        body: JSON.stringify(payload)
      }
    );

    const data = await res.json();

    if (data.success) {
      // ✅ Remove from CORRECT SECTION immediately
      setSlabSections(prevSections =>
        prevSections.map((section, sIndex) =>
          sIndex === sectionIndex
            ? {
                ...section,
                rows: section.rows.filter((_, rIndex) => rIndex !== rowIndex)
              }
            : section
        )
      );
      
      setPopupMessage("Discount slab deleted successfully");
      setPopupType("200or201");
      setShowPopup(true);
    } else {
      setPopupMessage(data.message || "Delete failed");
      setPopupType("400");
      setShowPopup(true);
    }
  } catch (error) {
    console.error("Delete error:", error);
    setPopupMessage("Something went wrong");
    setPopupType("500");
    setShowPopup(true);
  }

  // ✅ Reset with sectionIndex & rowIndex
  setDeleteConfirmed({ 
    show: false, 
    sectionIndex: null,
    rowIndex: null 
  });
  setTimeout(() => setShowPopup(false), 2000);
};

const handleAddSlabSection = () => {
  setSlabSections(prev => [
    ...prev,
    {
      id: Date.now(),
      rows: [getDefaultRow()]
    }
  ]);
};

const handleRowChange = (sectionIndex, rowIndex, field, value) => {
  setSlabSections(prevSections =>
    prevSections.map((section, sIndex) =>
      sIndex === sectionIndex
        ? {
            ...section,
            rows: section.rows.map((row, rIndex) =>
              rIndex === rowIndex ? { ...row, [field]: value } : row
            )
          }
        : section
    )
  );
};

const addRow = (sectionIndex) => {
  setSlabSections(prevSections =>
    prevSections.map((section, sIndex) =>
      sIndex === sectionIndex
        ? {
            ...section,
            rows: [
              ...section.rows,
              {
                ...getDefaultRow(),

                // ✅ COPY attributes from first row (or last row)
                attributes: section.rows[0]?.attributes || [],
                attributeIds: section.rows[0]?.attributeIds || []
              }
            ]
          }
        : section
    )
  );
};

const handleAttributeChange = (sectionIndex, selectedAttributes) => {
  setSlabSections(prevSections =>
    prevSections.map((section, sIndex) =>
      sIndex === sectionIndex
        ? {
            ...section,
            rows: section.rows.map(row => ({
              ...row,
              attributes: selectedAttributes,
              attributeIds: selectedAttributes.map(a => a.id)
            }))
          }
        : section
    )
  );
};

// const deleteRow = (index) => {
//   setRows(rows.filter((_, i) => i !== index));
// };

    const fetchVendors = async (Vendor,attempt = 1) => {
        try {
            const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedOrganizationId = sessionStorage.getItem('organizationId');
                const organizationId = decryptData(encryptedOrganizationId);
            const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET + `vendor/get-all-vendors?organizationId=${organizationId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-token':token
                }
            }); 
            const data = await response.json();
            if (data.status === 200 || data.status === 201 || data.status === 204) {
              setVendors(data.data);
              const FindVendor = data.data.find(p => p._id===Vendor._id)
              handleVendorClick(FindVendor);
              setIsLoading(false);
            } else {
              setIsLoading(false);
              setPopupMessage(data.message);
              setPopupType(`${data.status}`);
              setShowPopup(true);
            }
          } 
          catch (error) {
            console.error('Failed to fetch:', error);
        
            if (attempt < RETRY_LIMIT) {
              setRetryCount(attempt + 1); // Increment retry count
              setTimeout(() => fetchVendors(attempt + 1), 1000); // Retry after 1 second
            } else {
              setIsLoading(false);
              setPopupMessage('Internal Server Error. Kindly Retry.');
              setPopupType('500');
              setShowPopup(true);
              setRetryFunction(() => () => fetchVendors(attempt)); // Set retry function
            }
          }
        };


/* useEffect(()=>{
  if(selectedVendor){
  }else{
    setVendorid(VendorData._id);
    setSelectedVendor(VendorData)
    fetchProductCategoriesOfSelectedVendor(VendorData._id);
  }
},[VendorData]) */

const fetchProductCategories = async (attempt = 1) => {
  try {
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

      const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET + "product-category/get-all-productCategories", {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json',
              'x-token':token
          }
      });
      const data = await response.json();
      console.log('product category data', data);
      if (data.status === 200 || data.status === 201 || data.status === 204) {
        setCategories(data.data); 
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setPopupMessage(data.message);
        setPopupType(`${data.status}`);
        setShowPopup(true);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
  
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => fetchProductCategories(attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchProductCategories(attempt)); // Set retry function
      }
    }
  };

 const fetchProductSubcategoriesByProductCategoryId = async (productCategoryId) => {
  console.log('Fetching subcategories for productCategoryId:', productCategoryId);

  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}product-category/get-all-subcategories-and-UOMs-under-product-category?product_category_id=${productCategoryId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      }
    );

    const data = await response.json();
    console.log('Full API response:', data);
    console.log('subcategories data:', data?.data?.subCategories);

    if (data.status === 200) {

      const subCategories = data?.data?.subCategories;

      if (Array.isArray(subCategories)) {
        setSubCategoryMap(prev => ({
          ...prev,
          [productCategoryId]: subCategories
        }));
         setSubCategories(subCategories);

      } else {
        console.error('subCategories is not an array:', subCategories);
      }

    } else {
      setPopupMessage(data.message);
      setPopupType(`${data.status}`);
      setShowPopup(true);
    }

  } catch (error) {
    console.error('Failed to fetch:', error);
    setPopupMessage('Internal Server Error. Kindly Retry.');
    setPopupType('500');
    setShowPopup(true);
  }
};




  const fetchProductCategoriesOfSelectedVendor = async (idofvendor, attempt = 1) => {
    try {
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

      const response = await fetch(`${backendApiUrl}product-category/get-productCategoriesBy-vendor_id?vendor_id=${idofvendor}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      const data = await response.json();
      console.log('Vendor categories data:', data);
  
      if (data.status === 200 || data.status === 201 || data.status === 204) {
        if (Array.isArray(data.data)) {
          const assignedCategoryIds = data.data.map(category => category._id);
          setVendorCategories(assignedCategoryIds);
          console.log('Assigned category IDs:', assignedCategoryIds);
        } else if (data.status === 404) {
          console.error('Unexpected response format:', data);
          setVendorCategories([]);
          setSelectedCategories({});
        }
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setPopupMessage(data.message || 'An error occurred');
        setPopupType(`${data.status}`);
        setShowPopup(true);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => fetchProductCategoriesOfSelectedVendor(idofvendor, attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchProductCategoriesOfSelectedVendor(idofvendor, attempt)); // Set retry function
      }
    }
  };
  

  
  const handleCategoryChange = (categoryId) => {
    setVendorCategories(prevCategories => {
      // Check if the categoryId is already in the array
      const isCategoryIdPresent = prevCategories.includes(categoryId);
      
      // If the categoryId is present, remove it from the array
      if (isCategoryIdPresent) {
        return prevCategories.filter(id => id !== categoryId);
      }
      
      // If the categoryId is not present, add it to the array
      return [...prevCategories, categoryId];
    });
  };
  


const selectedCategoriesToassign ={
  vendor_id:vendorid,
  product_category_ids:product_category_ids,
}

 const fetchMovsByVendorId = async (vendorId, attempt = 1) => {
    try {
      console.log('Fetching MOVs for vendorId:', vendorId);
     const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

      const response = await fetch(`${backendApiUrl}movs/get-movs-by-vendorid?vendor_id=${vendorId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      const data = await response.json();
      console.log('MOV data:', data);
      if (data.status === 200 || data.status === 201 || data.status === 204) {
        setMovData(data.data || { categories: [], subcategories: [] });
      } else {
        console.error('Failed to fetch MOV data:', data.message);
        setMovData({ categories: [], subcategories: [] });
      }
    } catch (error) {
      console.error('Error fetching MOV data:', error);
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1);
        setTimeout(() => fetchMovsByVendorId(vendorId, attempt + 1), 1000);
      } else {
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
      }
    }
  };

const assignProductCategoriesToSelectedVendor = async (payload, attempt = 1) => {
  setIsSaving(true);

  console.log('Payload:', payload);  // Now logging the single combined payload

  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);


    // No need to combine further; payload is already combined
    const response = await fetch(
      `${backendApiUrl}product-category/assign-productCategory-to-vendor?vendor_id=${payload.vendor_id}`,  // Use payload.vendor_id
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify(payload),  // Send the full payload directly
      }
    );

    const data = await response.json();
    console.log('API response:', data); 

    if (data.status === 200 || data.status === 201 || data.status === 204) {
      setIsSaving(false);
      setShowAssignProductCategoryPopup(false);
      // Optionally show success message
      setPopupMessage(data.message || 'Categories assigned successfully');
      setPopupType('200or201');
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
    } else {
      setIsSaving(false);
      setPopupMessage(data.message || 'Failed to assign categories');
      setPopupType(`${data.status}`);
      setShowPopup(true);
    }
  } catch (err) {
    setIsSaving(false);
    console.error('Error in assignProductCategoriesToSelectedVendor:', err);
    setPopupMessage('Internal Server Error. Kindly Retry.');
    setPopupType('500');
    setShowPopup(true);
  }
};


useEffect(() => {
  if (selectedVendor) {
    fetchContactPersonsByVendorId(selectedVendor._id)
  }
}, [selectedVendor]);

useEffect(() => {
  if (showDiscountPopup && selectedVendor?._id) {
    console.log("🔥 Fetching discount for vendor:", selectedVendor._id);
    fetchDiscountSlabsByVendor();
  }
}, [showDiscountPopup, selectedVendor]); // ✅ ADD THIS


 

const fetchContactPersonsByVendorId = async (vendorId,attempt = 1) => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedOrganizationId = sessionStorage.getItem('organizationId');
                const organizationId = decryptData(encryptedOrganizationId);
    const GetContactPerson = `${backendApiUrl}vendor/get-vendor-and-contacts?vendor_id=${vendorId}`;
    const response = await fetch(GetContactPerson, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'x-token': token
      },
    });
    const data = await response.json();
    if (data.status === 200 || data.status === 201 || data.status === 204) {
      setVendorContactPersons(data.data.contacts? data.data.contacts : []);  
      setIsLoading(false);
    } else if (data.status === 404 ) {
      setVendorContactPersons([]);
      setIsLoading(false);
    }else if (data.status === 500 ) {
      setPopupMessage(data.message);
      setPopupType('500');
      setRetryFunction(() => fetchContactPersonsByVendorId);
      setShowPopup(true);
      setIsLoading(false);
    }
    else {
      setIsLoading(false);
      setRetryFunction(() => fetchContactPersonsByVendorId);
      setPopupMessage(data.message);
      setPopupType(`${data.status}`);
      setShowPopup(true);
    }
    }  catch (error) {
      console.error('Failed to fetch:', error);
  
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => fetchContactPersonsByVendorId(vendorId,attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchContactPersonsByVendorId(vendorId,attempt)); // Set retry function
      }
    }
    };

const fetchAttributesByCategory = async (categoryId, subCategoryId = null) => {
  if (!categoryId) return;

  console.log("🚀 Fetching Attributes for:", { categoryId, subCategoryId });

  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    const url = `${backendApiUrl}product-attributes/get-attr?product_category_id=${categoryId}&product_sub_category_id=${subCategoryId}`;

    const res = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'x-token': token
      }
    });

    const data = await res.json();
    console.log('📦 Attributes API Response:', data);

    if (data.success) {
      const attrList = data.data || [];

      // ✅ 1. SET GLOBAL ATTRIBUTES
      setAttributes(attrList);

      // ✅ 2. MAP EXISTING ATTRIBUTE IDS → VALUES (MAIN FIX)
      setSlabSections(prevSections =>
        prevSections.map(section => ({
          ...section,
          rows: section.rows.map(row => {
            const mappedAttributes = attrList
              .flatMap(attr => attr.attribute_values || [])
              .filter(val => row.attributeIds?.includes(val.attribute_value_id))
              .map(val => ({
                id: val.attribute_value_id,
                name: val.attribute_value
              }));

            return {
              ...row,
              attributes: mappedAttributes
            };
          })
        }))
      );
    }

  } catch (error) {
    console.error("❌ Error fetching attributes:", error);
  }
};

const handleVendorInputfieldChange = (e) => {
  const { id, value } = e.target;
  if (id === 'mobile_number') {
    // Check for numbers only
    if (!/^[0-9]*$/.test(value)) {
      return;
    }
    
    // Limit to 10 digits
    if (value.length > 10) {
      return;
    }

    // Validate first digit
    if (value.length === 1 && !['6','7','8','9'].includes(value)) {
      setErrorMessages(['Mobile number must start with 6, 7, 8 or 9']);
      return;
    }

    // Validate length
    if (value.length < 10 && value.length > 0) {
      setErrorMessages(['Enter 10 digits mobile number']);
    } else {
      setErrorMessages([]);
    }
  }


  setSelectedVendor((prevselectedVendor) => ({
     ...prevselectedVendor,
     [id]: value
  }));
};

const handleContactPersonInputfieldChange = (e) => {
  const { id, value } = e.target;
  setSelectedContactPerson((prevselectedContactPerson) => ({
     ...prevselectedContactPerson,
     [id]: value
  }));
};

const handleEditContactPerson = (contactPerson) => {
  setSelectedContactPerson(contactPerson);
  setShowEditContactPersonPopup(true);
};

const handleUpdateVendor = async (attempt = 1) => {
  const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedOrganizationId = sessionStorage.getItem('organizationId');
                const organizationId = decryptData(encryptedOrganizationId);
  const url = process.env.REACT_APP_FORE_BRICKBUCKET + "vendor/update-vendor";

 
  // Initialize error messages array
  const errorMessages = [];
  if (!selectedVendor.name) {
    errorMessages.push('Name is required.');
  }
    // Validate mobile number required
    if (!selectedVendor.mobile_number) {
      errorMessages.push('Mobile number is required.');
    } else if (selectedVendor.mobile_number.length !== 10) {
      // Validate mobile number length
      errorMessages.push('Mobile number must be exactly 10 digits.');
    }

  // Validate email if provided
  if (selectedVendor.email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(selectedVendor.email)) {
      errorMessages.push('Invalid email address.');
    }
  }

  // If there are any errors, display them and stop the execution
  if (errorMessages.length > 0) {
    setVendorEditErrors(errorMessages);
    setIsSaving(false);
    return;
  }
  setIsSaving(true); // Set isSaving to true when the Save button is clicked
  try {
   
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
      body: JSON.stringify(selectedVendor)
    });
    console.log('body', JSON.stringify(selectedVendor));
    const responseData = await response.json();
    if (responseData.status === 200 || responseData.status === 201 || responseData.status === 204) {
      handleSetUpdatingVendorsData(selectedVendor);
      setIsLoading(false);
      // Close the current popup and loader
      setVendorDetailsPopup(false);
      setIsSaving(false);
      setIsPanEditing(false);
      setIsGSTEditing(false);
      SetisAddressEditing(false)
      // Display a new popup with a 5-second timer and response message
      setShowPopup(true);
      setPopupType('200or201');
      setPopupMessage(responseData.message);
      setTimeout(() => {
        setShowPopup(false);
      }, 3000);
    } else if (responseData.status === 500) {
      setIsLoading(false);
      setIsSaving(false);
      setShowPopup(true);
      setPopupType('500');
      setRetryFunction(() => handleUpdateVendor);
      setPopupMessage(responseData.message);
      // Log the user out and redirect to login page
    } else {
      setIsSaving(false);
      setIsLoading(false);
      setPopupMessage(responseData.message);
      setPopupType(`${responseData.status}`);
      setShowPopup(true);
      setVendorDetailsPopup(false);
    }
  }  catch (error) {
    console.error('Failed to fetch:', error);

    if (attempt < RETRY_LIMIT) {
      setRetryCount(attempt + 1); // Increment retry count
      setTimeout(() => handleUpdateVendor(attempt + 1), 1000); // Retry after 1 second
    } else {
      setIsLoading(false);
      setPopupMessage('Internal Server Error. Kindly Retry.');
      setPopupType('500');
      setShowPopup(true);
      setRetryFunction(() => () => handleUpdateVendor(attempt)); // Set retry function
    }
  } finally {
    setErrorMessages([]);
  }
};

const handleSetUpdatingVendorsData = async (selectedVendor) => {
  const FindingVendorIndex = vendors.findIndex(p => p._id === selectedVendor._id);
  if (FindingVendorIndex !== -1) {
    // Create a new array with the updated vendor data to avoid mutating the state directly
    const updatedVendors = vendors.map((vendor, index) =>
      index === FindingVendorIndex
        ? { ...vendor, ...selectedVendor }
        : vendor
    );
    // Update the state with the new array
    setVendors(updatedVendors);
  }
};

  const handleVendorClick = (vendor) => {
  console.log("🟢 Vendor clicked:", vendor?._id);

  // ✅ CLOSE POPUP FIRST (very important)
  setShowDiscountPopup(false);

  // ✅ RESET ALL RELATED STATES
  setRows([]);
  setSelectedCategory("");
  setAttributes([]);
  setVendorCategories([]);
  setOpenDropdownIndex(null); 

  // ✅ SET NEW VENDOR
  setVendorid(vendor._id);
  setSelectedVendor({ ...vendor });

  setPurchaseOrders([]);

  console.log("📦 Fetching purchase orders for:", vendor._id);

  fetchVendorPurchaseOrders(vendor._id);
};

  const handleToggleAddress = () => {
    setShowAddress(!showAddress);
    setShowOtherDetails(false);
    setShowContactPersons(false);
    setShowBankAccountDetails(false);
  };

  const handleToggleOtherDetails = () => {
    setShowOtherDetails(!showOtherDetails);
    setShowContactPersons(false);
    setShowAddress(false);
    setShowBankAccountDetails(false);
  };

  const handleToggleContactPersons = () => {
    setShowContactPersons(!showContactPersons);
    setShowAddress(false);
    setShowOtherDetails(false);
    setShowBankAccountDetails(false);
  };

  const handleToggleBankAccountDetails = () => {
    setShowContactPersons(false);
    setShowAddress(false);
    setShowOtherDetails(false);
    setShowBankAccountDetails(!ShowBankAccountDetails);
  };

  const sortArray = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });

    const sortedArray = [...vendors].sort((a, b) => {
      if (a[key] < b[key]) {
       return direction === 'ascending' ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
    setVendors(sortedArray);
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? faSortUp : faSortDown;
    }
    return null;
  };

  const handleDeactivateClick = async (attempt = 1) => {
    setIsLoading(true);
    console.log(vendorid);
      try {
        const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedOrganizationId = sessionStorage.getItem('organizationId');
                const organizationId = decryptData(encryptedOrganizationId);
        const ActivateURL = `${backendApiUrl}vendor/deactivate-vendor?vendorId=${vendorid}`;
        const response = await fetch(ActivateURL, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
        const data = await response.json();
        console.log(data);
        if (data.status === 200 || data.status === 201 || data.status === 204) {
          setSelectedVendor((prevVendor) => ({ ...prevVendor, is_active: false }));
          setVendorStatus('Activate');
          setShowPopup(true);
          setIsLoading(false);
          setPopupType('200or201');
          setPopupMessage(data.message);
          setTimeout(() => {
            setShowPopup(false);
          }, 3000);
          // Update the vendor status in the local state
          setVendors(vendors.map((vendor) => {
            if (vendor._id === vendorid) {
              vendor.is_active = false;
            }
            return vendor;
          }));
        } else {
          setIsLoading(false);
          setPopupMessage(data.message);
          setPopupType(`${data.status}`);
          setShowPopup(true);
        }
      } catch (error) {
        console.error('Failed to fetch:', error);
        if (attempt < RETRY_LIMIT) {
          setRetryCount(attempt + 1); // Increment retry count
          setTimeout(() => handleDeactivateClick(attempt + 1), 1000); // Retry after 1 second
        } else {
          setIsLoading(false);
          setPopupMessage('Internal Server Error. Kindly Retry.');
          setPopupType('500');
          setShowPopup(true);
          setRetryFunction(() => () => handleDeactivateClick(attempt)); // Set retry function
        }
      }
    };
  
  const handleActivateClick = async (attempt = 1) => {
    setIsLoading(true);
      try {
        const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedOrganizationId = sessionStorage.getItem('organizationId');
                const organizationId = decryptData(encryptedOrganizationId);
        const ActivateURL = `${backendApiUrl}vendor/activate-vendor?vendorId=${vendorid}`;
        const response = await fetch(ActivateURL, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
        const data = await response.json();
        if (data.status === 200 || data.status === 201 || data.status === 204) {
          setSelectedVendor((prevVendor) => ({ ...prevVendor, is_active: true }));
          setVendorStatus('Deactivate');
          setShowPopup(true);
          setIsLoading(false);
          setPopupType('200or201');
          setPopupMessage(data.message);
          setTimeout(() => {
            setShowPopup(false);
          }, 3000);
          // Update the vendor status in the local state
          setVendors(vendors.map((vendor) => {
            if (vendor._id === vendorid) {
              vendor.is_active = true;
            }
            return vendor;
          }));
        } else {
          setIsLoading(false);
          setPopupMessage(data.message);
          setPopupType(`${data.status}`);
          setShowPopup(true);
        }
      } catch (error) {
        console.error('Failed to fetch:', error);
        if (attempt < RETRY_LIMIT) {
          setRetryCount(attempt + 1); // Increment retry count
          setTimeout(() => handleActivateClick(attempt + 1), 1000); // Retry after 1 second
        } else {
          setIsLoading(false);
          setPopupMessage('Internal Server Error. Kindly Retry.');
          setPopupType('500');
          setShowPopup(true);
          setRetryFunction(() => () => handleActivateClick(attempt)); // Set retry function
        }
      }
    };

const handleEditClick = () => {
  setVendorDetailsPopup(true);
};


const handlePlusIconClick = (contactPerson) => {
  setSelectedContactPerson(contactPerson);
  setShowAddContactPersonPopup(true);
};

const handleBankPlusIconClick = () => {
  setShowAddBankAccountDetails(true);
}


const handleClosePopup = () => {
  setIsSaving(false);
  setVendorEditErrors([]);
  setContactPersonErrors([]);
  setVendorDetailsPopup(false);
  setShowAddContactPersonPopup(false);
  setShowProjectDetailsPopup(false);
  setShowAssignProductCategoryPopup(false);
  setShowEditContactPersonPopup(false);
  setShowDeleteContactPersonPopup(false);
};

const handleUpdateContactPerson = async (attempt = 1) => {
  if (selectedContactPerson) {
    // Update contact person
    const updatedContactPerson = {
      _id: selectedContactPerson._id,
      customer_id: selectedContactPerson.customer_id,
      name: document.getElementById('name').value,
      email: document.getElementById('email').value,
      mobile_number: document.getElementById('mobile_number').value,
      designation: document.getElementById('designation').value,
    };

    const errorMessages = [];
    if (!updatedContactPerson.name) {
      errorMessages.push('Name is required.');
    }
      // Validate mobile number required
      if (!updatedContactPerson.mobile_number) {
        errorMessages.push('Mobile number is required.');
      } else if (updatedContactPerson.mobile_number.length !== 10) {
        // Validate mobile number length
        errorMessages.push('Mobile number must be exactly 10 digits.');
      }
  
     // Validate email if provided
     if (updatedContactPerson.email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(updatedContactPerson.email)) {
        errorMessages.push('Invalid email address.');
      }
    }

    if (errorMessages.length > 0) {
      setErrorMessages(errorMessages);
      return;
    }

    setIsSaving(true);
    try {
     const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedOrganizationId = sessionStorage.getItem('organizationId');
                const organizationId = decryptData(encryptedOrganizationId);
      const url = process.env.REACT_APP_FORE_BRICKBUCKET + "vendor/update-vendor-contact";
      const response = await fetch(url, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'x-token': token },
        body: JSON.stringify(updatedContactPerson),
      });

      const data = await response.json();
      if (data.status === 201 || data.status === 200 || data.status === 204) {
        setIsLoading(false);
        setIsSaving(false);
        setPopupMessage(data.message);
        setPopupType('200or201');
        setShowPopup(true);
        setTimeout(() => {
          setShowPopup(false);
        }, 3000);
        // Update successful, close the popup and update the CustomerContactPersons state
        const index = VendorContactPersons.findIndex((contactPerson) => contactPerson._id === selectedContactPerson._id);
        if (index !== -1) {
          const updatedVendorContactPersons = [...VendorContactPersons];
          updatedVendorContactPersons[index] = updatedContactPerson;
          setVendorContactPersons(updatedVendorContactPersons);
        }
        setShowEditContactPersonPopup(false);
      } else {
        setIsLoading(false);
        setIsSaving(false);
        setShowEditContactPersonPopup(false);
        setPopupMessage(data.message);
        setPopupType(`${data.status}`);
        setShowPopup(true);
        if (data.status === 500) {
          setRetryFunction(() => handleUpdateContactPerson);
        }
        setTimeout(() => {
          setShowPopup(false);
        }, 3000);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
  
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => handleActivateClick(attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setIsSaving(false);
        setShowEditContactPersonPopup(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setTimeout(() => {
          setShowPopup(false);
        }, 3000);
        setRetryFunction(() => () => handleActivateClick(attempt)); // Set retry function
      }
    }
    finally{
      setErrorMessages([]);
    }
  }
};

  const handleCreateContactPerson = async (attempt = 1) => {
    // Save new contact person
    const newContactPerson = {
      vendor_id: vendorid, // Assuming you have a customerId state or prop
      name: document.getElementById('name').value,
      email: document.getElementById('email').value,
      mobile_number: document.getElementById('mobile_number').value,
      designation: document.getElementById('designation').value,
    };
  
    const errorMessages = [];
    if (!newContactPerson.name) {
      errorMessages.push('Name is required.');
    }
      // Validate mobile number required
      if (!newContactPerson.mobile_number) {
        errorMessages.push('Mobile number is required.');
      } else if (newContactPerson.mobile_number.length !== 10) {
        // Validate mobile number length
        errorMessages.push('Mobile number must be exactly 10 digits.');
      }
     // Validate email if provided
     if (newContactPerson.email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(newContactPerson.email)) {
        errorMessages.push('Invalid email address.');
      }
    } 
    if (errorMessages.length > 0) {
      setContactPersonErrors(errorMessages);
      return;
    }
  
    setIsSaving(true);
    try {
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedOrganizationId = sessionStorage.getItem('organizationId');
                const organizationId = decryptData(encryptedOrganizationId);
      const url = process.env.REACT_APP_FORE_BRICKBUCKET + "vendor/create-vendor-contact";
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-token': token },
        body: JSON.stringify(newContactPerson),
      });
      const data = await response.json();
      if (data.status === 201 || data.status === 200 || data.status === 204){      
        setIsLoading(false);
        setIsSaving(false);
        setPopupMessage(data.message);
        setPopupType('200or201');
        setShowPopup(true);
        setTimeout(() => {
          setShowPopup(false);
        }, 3000);
        // Save successful, close the popup and update the CustomerContactPersons state
        setShowAddContactPersonPopup(false);
        const newVendorContactPersons = [...VendorContactPersons, data.data];
        setVendorContactPersons(newVendorContactPersons);
      } else {
        setIsLoading(false);
        setIsSaving(false);
        setShowAddContactPersonPopup(false);
        setPopupMessage(data.message);
        setPopupType(`${data.status}`);
        setShowPopup(true);
        if (data.status === 500) {
          setRetryFunction(() => handleCreateContactPerson);
        }
        setTimeout(() => {
          setShowPopup(false);
        }, 3000);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
  
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => handleActivateClick(attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setIsSaving(false);
        setShowEditContactPersonPopup(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setTimeout(() => {
          setShowPopup(false);
        }, 3000);
        setRetryFunction(() => () => handleCreateContactPerson(attempt)); // Set retry function
      }
    }
    finally{
      setErrorMessages([]);
    }
  };

const handleCreateContactPersonInputfieldChange = (e) => {
  const { id, value } = e.target;
   
  if (id === 'mobile_number') {
    // Check for numbers only
    if (!/^[0-9]*$/.test(value)) {
      return;
    }
    
    // Limit to 10 digits
    if (value.length > 10) {
      return;
    }

    // Validate first digit
    if (value.length === 1 && !['6','7','8','9'].includes(value)) {
      setErrorMessages(['Mobile number must start with 6, 7, 8 or 9']);
      return;
    }

    // Validate length
    if (value.length < 10 && value.length > 0) {
      setErrorMessages(['Enter 10 digits mobile number']);
    } else {
      setErrorMessages([]);
    }
  }

  
  setNewContactPerson((prevNewContactPerson) => ({ ...prevNewContactPerson, [id]: value }));
};

const handleUpdateContactPersonInputfieldChange = (e) => {
  const { id, value } = e.target;
  setSelectedContactPerson((prevSelectedContactPerson) => ({ ...prevSelectedContactPerson, [id]: value }));
};

const handleDropdownChange = (value) => {
  setSalutation(value);
};

const handleApprove = async () => {
  setLoading(true);
  const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedOrganizationId = sessionStorage.getItem('organizationId');
                const organizationId = decryptData(encryptedOrganizationId);

  try {
    const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET +'vendor/approve-vendor', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token 
      },
      body: JSON.stringify({ _id: vendorid }),
    });

    const data = await response.json();
    console.log(data);
  
    if (data.success === true)  {
      console.log(data.vendor_status)
      setVendorApprovalStatus(3); // Set the vendor status to approved (3)
      setPopupMessage('vendor approved successfully');
      setPopupType('200or201');
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
      }, 3000);

    }
  } catch (error) {
    console.error('Error approving vendor:', error);
  } finally {
    setLoading(false);
  }
};

const handleDisapprove = async () => {
  const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedOrganizationId = sessionStorage.getItem('organizationId');
                const organizationId = decryptData(encryptedOrganizationId);

  setLoading(true);
  try {
    const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET +'vendor/disapprove-vendor', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token 
      },
      body: JSON.stringify({ _id: vendorid }),
    });

    const data = await response.json();
    console.log(data);
    if (data.success === true) {
      console.log(data.vendor_status)
      setVendorApprovalStatus(2); // Set the vendor status to disapproved (2)
      setPopupMessage('vendor disapproved successfully');
      setPopupType('200or201');
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
      }, 3000);

    }
  } catch (error) {
    console.error('Error disapproving vendor:', error);
  } finally {
    setLoading(false);
  }
};

const SalutationOptions = [
  { label: 'Mr.', value: 'Mr.' },
  { label: 'Mrs.', value: 'Mrs.' },
  { label: 'Ms.', value: 'Ms.' },
  { label: 'Miss.', value: 'Miss.' },
  { label: 'Dr.', value: 'Dr.' },
];

const [isPanEditing, setIsPanEditing] = useState(false);
const [panValue, setPanValue] = useState();
const [isGSTEditing, setIsGSTEditing] = useState(false);
const [GSTValue, setGSTValue] = useState();
const [address, setAddress]=useState()
  const [city, setCity]=useState()
  const [isAddressEditing, SetisAddressEditing] = useState (false)

const handleEditPanClick = () => {
  setIsPanEditing(true);
  setIsGSTEditing(false)
  setPanValue(selectedVendor.pan)
};
const handleEditGSTClick = () => {
  setIsGSTEditing(true);
  setGSTValue(selectedVendor?.gstin || '');
  setPanValue(selectedVendor?.pan || '');
};

const handleEditAddress = () =>{
  SetisAddressEditing(true)
  setIsPanEditing(false);
  setIsGSTEditing(false)
  setAddress(selectedVendor.address)
  setCity(selectedVendor.city)
}
 

const handleCancelClick = () => {
  setIsPanEditing(false);
  setIsGSTEditing(false);
  SetisAddressEditing (false)
};

const handleAssignProductCategoryPopup = async () => {
  fetchProductCategories();
  fetchProductCategoriesOfSelectedVendor(selectedVendor._id);
  await fetchMovsByVendorId(selectedVendor._id);
  setShowAssignProductCategoryPopup(true);
};

const handleDeleteContactPerson = (contactPerson) => {
  setSelectedContactPerson(contactPerson);
  setShowDeleteContactPersonPopup(true);
}

const handleConfirmDelete = async (attempt = 1) => {
  const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedOrganizationId = sessionStorage.getItem('organizationId');
                const organizationId = decryptData(encryptedOrganizationId);
  const vendorContactId = selectedContactPerson._id;
  setIsSaving(true);
  try {
    const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET + `vendor/delete-vendor-contact?vendor_contacts_id=${vendorContactId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        "x-token": token
      }
    });
    const data = await response.json();
    if (data.status === 200 || data.status === 201 || data.status === 204) {
      setIsLoading(false);
      setIsSaving(false);
      setPopupMessage(data.message);
      setPopupType('204');
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
      }, 3000);
      // Update successful, close the popup and update the CustomerContactPersons state
      const index = VendorContactPersons.findIndex((contactPerson) => contactPerson._id === vendorContactId);
      if (index !== -1) {
        const updatedVendorContactPersons = [...VendorContactPersons];
        updatedVendorContactPersons.splice(index, 1); // Remove the deleted contact person
        setVendorContactPersons(updatedVendorContactPersons);
      }
      setShowDeleteContactPersonPopup(false);
    } else {
      setIsLoading(false);
      setIsSaving(false);
      setPopupMessage(data.message);
      setPopupType(`${data.status}`);
      setShowPopup(true);
      if (data.status === 500) {
        setRetryFunction(() => handleConfirmDelete);
      }
      setTimeout(() => {
        setShowPopup(false);
      }, 3000);
      setShowDeleteContactPersonPopup(false);
    }
  } catch (error) {
    console.error('Failed to fetch:', error);

    if (attempt < RETRY_LIMIT) {
      setRetryCount(attempt + 1); // Increment retry count
      setTimeout(() => handleConfirmDelete(attempt + 1), 1000); // Retry after 1 second
    } else {
      setIsLoading(false);
      setIsSaving(false);
      setShowEditContactPersonPopup(false);
      setPopupMessage('Internal Server Error. Kindly Retry.');
      setPopupType('500');
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
      }, 3000);
      setRetryFunction(() => () => handleConfirmDelete(attempt)); // Set retry function
    }
  }
}

const fetchVendorPurchaseOrders = async (vendorId, attempt = 1) => {
  console.log("Fetching purchase orders for vendorId:", vendorId);


  try {
   const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedOrganizationId = sessionStorage.getItem('organizationId');
                const organizationId = decryptData(encryptedOrganizationId);
    const getPurchaseOrdersUrl = `${process.env.REACT_APP_FORE_BRICKBUCKET}vendor/get-vendor-purchaseorders?vendor_id=${vendorId}`;
console.log(getPurchaseOrdersUrl)
    const response = await fetch(getPurchaseOrdersUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'x-token': token
      },
    });

    const data = await response.json();

    if (response.ok) {
      if (data.status === 200 || data.status === 201 || data.status === 204) {
       setPurchaseOrders(data.data || []);
        console.log(data.data);
      } else if (data.status === 404) {
        setPurchaseOrders([]);
      }
      setIsLoading(false);
    } else {
      if (data.status === 500) {
        setPopupMessage(data.message || 'Internal Server Error');
        setPopupType('500');
      } else {
        setPopupMessage(data.message || `Error: ${response.status}`);
        setPopupType(`${data.status || response.status}`);
      }
      setRetryFunction(() => () => fetchVendorPurchaseOrders(vendorId, attempt));
      setShowPopup(true);
      setIsLoading(false);
    }
  } catch (error) {
    console.error('Failed to fetch:', error);

    if (attempt < RETRY_LIMIT) {
      setRetryCount(attempt + 1);
      setTimeout(() => fetchVendorPurchaseOrders(vendorId, attempt + 1), 1000);
    } else {
      setIsLoading(false);
      setPopupMessage('Internal Server Error. Kindly Retry.');
      setPopupType('500');
      setShowPopup(true);
      setRetryFunction(() => () => fetchVendorPurchaseOrders(vendorId, attempt));
    }
  }
};

const handleDiscountClick = () => {
  console.log("🟡 Discount clicked:", selectedVendor?._id);

  setSelectedCategory("");
  setSelectedSubCategory("");
  setAttributes([]);
  setOpenDropdownIndex(null);

  setShowDiscountPopup(true);

  fetchProductCategories();
  fetchProductCategoriesOfSelectedVendor(selectedVendor._id);

  // ❌ REMOVE this line (this is causing overwrite)
  // setRows([getDefaultRow()]);
};


const handleCreateVendor = () => {
  navigate('/bb/app/purchases/newvendor'); 
};

const HandleClose = () => {
  navigate('/bb/app/purchases/vendorslist'); 
};

const handleCloseError = () => {
  setErrorMessages([]);
};

const handleEdit = () => {
  navigate('/bb/app/purchases/EditVendor',  {state:{VendorData:selectedVendor}});
  console.log(VendorData);
}
const closePopup = () => {
  console.log("closePopup called");
  setShowPopup(false);
};

const handlenavigateToPurchaseOrderDetails = (po) => {
  navigate("/bb/app/purchases/purchaseorderdetails", {state:{PurchaseOrderData:po}});
  console.log(po);
}

if (isLoading) {
  return <Loader />;
}

const Retry = async () => {
  console.log("Retry called");
  setIsLoading(true); // Show loader
  setTimeout(async () => {
    if (retryFunction) {
      await retryFunction();
    }
    setIsLoading(false); // Hide loader after retry
  }, 5000); // 5-second delay
  setShowPopup(false);
};

const BackToLoginPage = () => {
  console.log("Back To Login Page");
  setShowPopup(false);
  localStorage.removeItem('LoginData');
  sessionStorage.removeItem('userData');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('userId');
  sessionStorage.removeItem('appId');
navigate('/bb');
};

const getSubCategoryName = (subCategoryId) => {
  if (!subCategoryId) return "Category Level";
  
  const allSubCategories = Object.values(subCategoryMap).flat();
  const subCat = allSubCategories.find(sub => sub._id === subCategoryId);
  
  return subCat?.product_sub_category_name || 
         subCategories.find(sub => sub._id === subCategoryId)?.product_sub_category_name ||
         "Unknown Subcategory";
};

const getCurrentLocation = () => {
  if (!navigator.geolocation) {
    alert('Geolocation is not supported by your browser');
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      setLatitude(lat.toFixed(6));
      setLongitude(lng.toFixed(6));
    },
    (error) => {
      alert('Unable to fetch location');
      console.error(error);
    }
  );
};


const handleSaveLocation = async () => {
  console.log("🔥 SAVE LOCATION CLICKED! lat:", latitude, "lng:", longitude);

  const locationObj = { lat: Number(latitude), lng: Number(longitude) };

  console.log("📍 Location obj:", locationObj);

selectedVendor.location = locationObj;
  console.log("📤 Final payload.location:", selectedVendor.location);

  await handleUpdateVendor();

  // ✅ ADD THESE 2 LINES
  setOriginalLatitude(latitude);
  setOriginalLongitude(longitude);
};


const handleStatus = async () => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedOrganizationId = sessionStorage.getItem('organizationId');
                const organizationId = decryptData(encryptedOrganizationId);
    const url = process.env.REACT_APP_FORE_BRICKBUCKET + "vendor/vendor-status-update";
    
    const payload = {
      _id: selectedVendor._id,
      vendor_status: selectedVendor.vendor_status === 3 ? 1 : 3
    };

    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();

    if (data.status === 200 || data.status === 201) {
      // Update the local state with the new vendor status
      setSelectedVendor(prevVendor => ({
        ...prevVendor,
        vendor_status: payload.vendor_status
      }));
   setShowPopup(true);
      // Show success popup
      setPopupType('200or201');
      setPopupMessage(data.message);
   
      setTimeout(() => {
        setShowPopup(false);
      }, 3000);
    } else {
      // Show error popup
      setPopupType(`${data.status}`);
      setPopupMessage(data.message);
      setShowPopup(true);
    }
  } catch (error) {
    console.error('Failed to update vendor status:', error);
    setPopupType('500');
    setPopupMessage('Internal Server Error. Kindly Retry.');
    setShowPopup(true);
  }finally{
    setIsLoading(false);
  }
};


const handleSaveDiscountSlabs = async () => {
  try {
    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);

    // ✅ Validate
    for (let sectionIndex = 0; sectionIndex < slabSections.length; sectionIndex++) {
      for (let rowIndex = 0; rowIndex < slabSections[sectionIndex].rows.length; rowIndex++) {
        const row = slabSections[sectionIndex].rows[rowIndex];
        if (!row.mov || Number(row.mov) <= 0) {
          setPopupMessage("Please enter a MOV value for all rows.");
          setPopupType("400");
          setShowPopup(true);
          return;
        }
      }
    }

    // ✅ CHECK subcategory
    const isSubCategory = !!selectedSubCategory;

    // ✅ BUILD PAYLOAD
    const payload = {
      categories: !isSubCategory
        ? slabSections.flatMap(section =>
            section.rows.map(row => ({
              vendor_id: selectedVendor?._id,
              product_category_id: selectedCategory,
              product_sub_category_id: null,
              attribute_value_ids: row.attributes?.map(attr => attr.id) || [],
              movs: [{
                mov: Number(row.mov),
                discount: Number(row.discount || 0)
              }]
            }))
          )
        : [],

      subcategories: isSubCategory
        ? slabSections.flatMap(section =>
            section.rows.map(row => ({
              vendor_id: selectedVendor?._id,
              product_category_id: selectedCategory,
              product_sub_category_id: selectedSubCategory,
              attribute_value_ids: row.attributes?.map(attr => attr.id) || [],
              movs: [{
                mov: Number(row.mov),
                discount: Number(row.discount || 0)
              }]
            }))
          )
        : []
    };

    console.log("🔥 FINAL PAYLOAD:", JSON.stringify(payload, null, 2));

    const res = await fetch(
      `${backendApiUrl}discount/create-or-update-discountslab`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token
        },
        body: JSON.stringify(payload)
      }
    );

    const data = await res.json();

    if (data.status === 200 || data.status === 201) {
      setPopupMessage("Discount slabs saved successfully ✅");
      setPopupType('200or201');
      setShowPopup(true);

      setTimeout(() => {
        fetchDiscountSlabsByVendor();
        setShowDiscountPopup(false);
        setShowPopup(false);
      }, 1500);

    } else {
      setPopupMessage(data.message || "Failed to save");
      setPopupType(`${data.status}`);
      setShowPopup(true);
    }

  } catch (error) {
    console.error("Save error:", error);
    setPopupMessage("Network error. Please try again.");
    setPopupType("500");
    setShowPopup(true);
  }
};


const fetchDiscountSlabsByVendor = async () => {
  setIsDiscountLoading(true); // ✅ START LOADING

  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    const res = await fetch(
      `${backendApiUrl}discount/get-discountslabs-by-vendorid?vendor_id=${selectedVendor?._id}`,
      { method: "GET", headers: { "x-token": token } }
    );

    const data = await res.json();

    let slabsData = [];

    if (data.data?.subcategories?.length > 0) {
      slabsData = data.data.subcategories;
    } else if (data.data?.categories?.length > 0) {
      slabsData = data.data.categories;
    }

    if (data.success && slabsData.length > 0) {
      const categoryId = slabsData[0].product_category_id;

      await fetchProductSubcategoriesByProductCategoryId(categoryId);

      const sections = slabsData.map((item, index) => ({
        id: Date.now() + index,
        subCategoryName: getSubCategoryName(item.product_sub_category_id),
        subCategoryId: item.product_sub_category_id,
        categoryId: item.product_category_id,
        rows: (item.movs || []).map((movItem) => ({
          mov: movItem.mov || "",
          discount: movItem.discount || "",
          document_id: item._id,
          isExisting: true,
          attributeIds: item.attribute_value_ids || [],
          attributes: [],
        }))
      }));

      setSlabSections(sections);
      setSelectedCategory(categoryId);
      setSelectedSubCategory(slabsData[0].product_sub_category_id || "");

      fetchAttributesByCategory(categoryId, slabsData[0].product_sub_category_id);

    } else {
      // ✅ only set default when NO DATA
      setSlabSections([{
        id: Date.now(),
        rows: [getDefaultRow()]
      }]);
    }

  } catch (error) {
    console.error("Fetch discount error:", error);
  } finally {
    setIsDiscountLoading(false); // ✅ END LOADING
  }
};


const deleteRow = (sectionIndex, rowIndex) => {
  const row = slabSections[sectionIndex].rows[rowIndex];
  
  // 🟢 NEW ROW → direct delete
  if (!row.isExisting) {
    setSlabSections(prevSections =>
      prevSections.map((section, sIndex) =>
        sIndex === sectionIndex
          ? {
              ...section,
              rows: section.rows.filter((_, i) => i !== rowIndex)
            }
          : section
      )
    );
    return;
  }

  // 🔴 EXISTING ROW → confirm delete
  setDeleteConfirmed({
    show: true,
    sectionIndex,  // ✅ Add sectionIndex
    rowIndex
  });
};





return (

    <div className=" bg-white flex flex-row w-full justify-center overflow-y-hidden">
{/* List of Vendors Div start */}
      <div className=" flex flex-col  w-[32%]  ">
  <div className="p-4 border-b  flex flex-row justify-between ">
    <div>
    <h5 className="text-md font-semibold cursor-pointer ">All Vendors
     <FontAwesomeIcon icon={faChevronDown} className="text-xs mb-0.5 text-blue-600 mx-1 cursor-pointer " />
    </h5>
    </div>
    <div className=''>
    <button 
  className="mr-2 bg-[#f7525a] text-white px-1 py-0.5 rounded-md"  data-tooltip="Create Vendor" title=""  style={{ '--tooltip-bg': 'black' }}
  onClick={handleCreateVendor}>
  <FontAwesomeIcon icon={faPlus}  className="mb-0.5 text-xs text-white mx-1 cursor-pointer" />
</button>
</div>
  </div>
<div className='flex justify-center items-center mt-2 pb-2 px-3 border-b'>
 <div className="mx-auto">
    <Search
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      searchType={searchType}
      setSearchType={setSearchType}
      searchTypes={searchTypes}
      placeholder="Search vendors..."
      onSearch={handleSearch}
      onSearchSubmit={handleSearch}
    />
  </div>
</div>

  <div className=" flex justify-center  overflow-y-hidden  flex-col ">
   <div className='flex  flex-col h-[80vh]  overflow-y-auto '
    ref={listContainerRef}>
       {filteredVendors.length === 0 ? (
    <div className="flex justify-center items-center py-10">
       <div className="flex flex-col items-center text-gray-500">
     <FontAwesomeIcon
       icon={faSearch}
       className="text-2xl mb-2"
     />
     <p className="text-sm">No Results Found</p>
   </div>
   </div>
  ) : (
   filteredVendors.map((vendor) => (
        <div
          key={vendor._id}
          ref={(el) => (itemRefs.current[vendor._id] = el)}
          onClick={() => handleVendorClick(vendor)}
          className={`border-b text-sm flex items-center px-4 py-2 ${vendorid === vendor._id ? 'bg-gray-100' : ''} hover:bg-gray-100 cursor-pointer`}
        >
          <div className='flex flex-row'>
            <div>
<input
  type="checkbox"
  className="mr-2 w-3 h-3 accent-blue-600 cursor-pointer"
/>            </div>
            <div className='flex flex-col'>
              <p className='text-md font-semibold' >{vendor.name}</p>
              <p className="text-gray-600 text-sm">{vendor.company_name}</p>
            </div>
          </div>
        </div>
      ))
    )}

  </div>

</div>
</div>
{/* List of Vendors Div end */}

<div className="border-l  w-full flex flex-col ">


<div className="border-b h-20"> {/* or h-12, depending on your desired height */}
  <div className='p-4 flex justify-between items-center '>
    <span className="text-md font-semibold">{selectedVendor.name}</span>
    <div className="flex items-center px-2">
      <button className="bg-gray-100 px-2 py-1 shadow-sm text-sm border rounded-md mr-2" onClick={handleEdit}>
        Edit
      </button>
      {/* <button className="bg-gray-100 px-1 py-1 shadow-sm text-sm border rounded-md mr-2">
        <FontAwesomeIcon icon={faPaperclip} className="text-md text-black mx-2 cursor-pointer " />
      </button>
      <button className="bg-[#f7525a] text-sm text-white px-2 py-1 shadow-sm border rounded-md mr-2">
        New Transaction
      </button> */}
    <button onClick={handleAssignProductCategoryPopup}
    className="bg-gray-100 text-sm px-2 py-1 shadow-sm border rounded-md mr-2">
      Assign
    </button>
        
       <button
         onClick={handleDiscountClick}
    className="bg-gray-100 text-sm px-2 py-1 shadow-sm border rounded-md mr-2">
      Discount
    </button>

        <button className=" text-white px-1 py-1 rounded-md "
         title="" data-tooltip="Close"  style={{ '--tooltip-bg': 'black' }}>   
        <FontAwesomeIcon icon={faX} onClick={HandleClose} className="text-md text-[#f7525a] mx-2 cursor-pointer " />
      </button>
    </div>
  </div>
</div>
  <div className=" flex h-5/6 w-full  overflow-y-auto  flex-row">
  <div className="bg-[#fbfbfb] w-[32%] border-r  p-4">
    <h2 className="text-sm pb-2 border-b">
    {selectedVendor.company_name}
    </h2>
    <div className='pt-4 pl-4 pr-4  flex flex-row'>
    <div className='flex-shrink-0'>
 <img 
  className="rounded-md w-10 h-10 cursor-pointer"
  src={
    selectedVendor.image
      ? `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${selectedVendor.image}`
      : '/ProfileImageSvg.jpg'
  }
  alt="Vendor Logo"
  onError={(e) => {
    e.target.onerror = null;
    e.target.src = '/ProfileIcon.webp';
  }}
/>
</div>

  <div className=' text-sm ml-3 flex flex-col'>
    <div className='font-semibold mb-0.5 break-words word-break'>{selectedVendor.name}</div>
    <div className='break-words word-break'>{selectedVendor.email}</div>
    <div className='break-words word-break'>
      <FontAwesomeIcon icon={faMobileAndroidAlt} className='mr-1 text-xs'/>
      {selectedVendor.mobile_number}
    </div>
    <div className='text-xs flex flex-row'>
      <button onClick={handleEditClick} className='text-[#408dfb] hover:text-blue-600'>Edit</button>
      <p className='text-gray-300 ml-2 mr-2 '>|</p>
      <button
      onClick={selectedVendor.is_active ? handleDeactivateClick : handleActivateClick}
      className='text-[#408dfb] hover:text-blue-600' >
      {selectedVendor.is_active ? 'Deactivate' : 'Activate'}
    </button>  </div>
  </div>
</div>

<div onClick={handleToggleAddress}  className='pt-4 pl-4 pr-4 border-b flex flex-row justify-between items-center'>
  <span className=' text-sm cursor-pointer' onClick={handleToggleAddress}>ADDRESS</span>
  <button className=' text-gray-500 hover:text-gray-800 transition duration-300 ease-in-out' onClick={handleToggleAddress}>
    {showAddress? <FontAwesomeIcon icon={faChevronUp} className='text-xs text-blue-800'/> : <FontAwesomeIcon icon={faChevronDown} className='text-xs text-blue-800'/>}
  </button>
</div>

<div className={`${showAddress ? '' : 'hidden'}`}>
  <div className='text-sm pt-2 pl-4 pr-4'>
    <div className='flex justify-between'><h1>Billing Address</h1>
    {!isAddressEditing&&
    <FontAwesomeIcon icon={faPen} className='text-xs'
    onClick={handleEditAddress}/> 
    }
    </div>

    <div className='flex flex-col'>
    <div className='flex flex-row hover:bg-[#d7d7ec] hover:rounded-md'>
<div className='flex-1 text-xs pt-2 pb-2 pl-1 pr-1 flex justify-end'>
    {isAddressEditing ? (
      <div className='flex flex-col space-y-2'>
      <input 
        type="text" 
        value={address} 
        onChange={(e) => {setAddress(e.target.value); selectedVendor.address = e.target.value}} 
        className="border border-gray-300 w-30 rounded px-2 py-1"
      />
      <input 
        type="text" 
        value={city} 
        onChange={(e) => {setCity(e.target.value); selectedVendor.city = e.target.value}} 
        className="border border-gray-300 w-30 rounded px-2 py-1"
      />
       </div>
    ) : (
 <>
 <div className='flex flex-col space-y-2'>

  <p>{selectedVendor.address}</p>

  <p>{selectedVendor.city}</p>
  </div>
  </>
)}
  <div className='flex items-center'>
  {isSaving && (
    <Spinner/>
  )}
    {isAddressEditing &&(
      <>
        <FontAwesomeIcon 
          icon={faSave} 
          className='mr-2 text-xs ml-2 cursor-pointer' 
          onClick={handleUpdateVendor} 
        />
        <FontAwesomeIcon 
          icon={faTimes} 
          className='mr-2 text-xs ml-2 cursor-pointer' 
          onClick={handleCancelClick} 
        />
      </>
    )}
  </div>
  </div>
</div>
    </div>
  </div>
</div>

<div
  onClick={() => setShowLocation(!showLocation)}
  className="pt-4 pl-4 pr-4 border-b flex justify-between items-center cursor-pointer"
>
  <span className="text-sm ">LOCATION</span>
  <FontAwesomeIcon
    icon={showLocation ? faChevronUp : faChevronDown}
    className="text-xs"
  />
</div>


{showLocation && (
  <div className="px-4 py-3">

    <div className="flex justify-between items-start">

      {/* LEFT SIDE : Latitude & Longitude */}
      <div className="space-y-2">

        {/* Latitude */}
        <div className="flex flex-col">
          <label className="text-xs font-semibold mb-1">Latitude</label>
          <input
            type="text"
            value={latitude}
            onChange={(e) => setLatitude(e.target.value)}
            className="border p-1 rounded text-sm w-40"
            placeholder="Enter latitude"
          />
        </div>

        {/* Longitude */}
        <div className="flex flex-col">
          <label className="text-xs font-semibold mb-1">Longitude</label>
          <input
            type="text"
            value={longitude}
            onChange={(e) => setLongitude(e.target.value)}
            className="border p-1 rounded text-sm w-40"
            placeholder="Enter longitude"
          />
        </div>

      </div>

      {/* RIGHT SIDE : Map + Save */}
      <div className="flex flex-col items-center ml-4 mt-5">
        <FontAwesomeIcon
          icon={faMapMarkerAlt}
         onClick={getCurrentLocation}
          className="text-blue-500 border border-gray-400 p-1.5 w-6 h-6 cursor-pointer rounded mb-1"
          title="Pick from map"
        />
        {shouldShowSave && (
        <button
          onClick={handleSaveLocation}
          className="bg-blue-500 text-white text-xs mt-6 px-2 py-0.5 rounded"
        >
          Save
        </button>
        )}
      </div>

    </div>

  </div>
)}




<div onClick={handleToggleOtherDetails}  className='pt-4 pl-4 pr-4 border-b flex flex-row justify-between items-center'>
  <span className='text-sm cursor-pointer' onClick={handleToggleOtherDetails}>TAX DETAILS</span>
  <button className='ml-2 text-gray-500 hover:text-gray-800 transition duration-300 ease-in-out' onClick={handleToggleOtherDetails}>
    {showOtherDetails? <FontAwesomeIcon icon={faChevronUp} className='text-xs'/> : <FontAwesomeIcon icon={faChevronDown} className='text-xs'/>}
  </button>
</div>

<div className={`${showOtherDetails? '' : 'hidden'} mt-2 mb-2 flex flex-col `}>

  <div className='flex flex-row pb-2 '>
  <div className='text-[#212529] text-xs pt-2 pl-2 pr-2 w-32'>
    <h1>GSTIN</h1>
  </div>

  <div className='flex flex-row hover:bg-[#d7d7ec] hover:rounded-md'>
    <div className='flex-1 text-xs pt-2 pb-2 pl-1 pr-1 flex justify-end'>
      {isGSTEditing ? (
        <>
          <input
            type="text"
            value={GSTValue}
            onChange={(e) => {
            const gst = e.target.value.toUpperCase();
           setGSTValue(gst);

          setSelectedVendor(prev => ({
               ...prev,
             gstin: gst,
         pan: gst.length >= 12 ? gst.substring(2, 12) : ''
            }));

           // update PAN display
          if (gst.length >= 12) {
           setPanValue(gst.substring(2, 12));
           } else {
           setPanValue('');
             }
            }}
            className="border border-gray-300 w-24 rounded px-2 py-1"
          />
          {errorMessages.length > 0 && (
            <span className="text-red-500 text-xs mt-1">{errorMessages[0]}</span>
          )}
        </>
      ) : (
        <p>{selectedVendor && selectedVendor.gstin ? selectedVendor.gstin : ''}</p>
      )}
    </div>

    <div className='flex items-center'>
      {isSaving && <Spinner />}
      {isGSTEditing ? (
        <>
          <FontAwesomeIcon
            icon={faSave}
            className='mr-2 text-xs ml-2 cursor-pointer'
            onClick={handleUpdateVendor}
          />
          <FontAwesomeIcon
            icon={faTimes}
            className='mr-2 text-xs ml-2 cursor-pointer'
            onClick={handleCancelClick}
          />
        </>
      ) : (
        <FontAwesomeIcon
          icon={faPen}
          className='mr-2 text-xs ml-2 cursor-pointer'
          onClick={handleEditGSTClick}
        />
      )}
    </div>
  </div>
</div>
<div className='flex flex-row pb-2 '>
  <div className='text-[#212529] text-xs pt-2 pl-2 pr-2 w-32'>
    <h1>PAN</h1>
  </div>

  <div className='flex flex-row hover:bg-[#d7d7ec] hover:rounded-md'>
    <div className='flex-1 text-xs pt-2 pb-2 pl-1 pr-1 flex justify-end'>
<p>{isGSTEditing ? panValue : selectedVendor?.pan || ''}</p> 
   </div>
  </div>
</div>


</div>

<div onClick={handleToggleContactPersons}  className='pt-4 pl-4 pr-4 border-b flex flex-row justify-between items-center'>
  <div>
  <span className='text-sm cursor-pointer' onClick={handleToggleContactPersons}>CONTACT PERSONS</span>
  </div>
  <div>
  <button className='ml-2 text-gray-500 hover:text-gray-800 transition duration-300 ease-in-out' onClick={handleToggleContactPersons}>
    <FontAwesomeIcon icon={faPlusCircle} onClick={handlePlusIconClick} className='text-blue-500 text-md'/>
  </button>
  <button className='ml-2 text-gray-500 hover:text-gray-800 transition duration-300 ease-in-out' onClick={handleToggleContactPersons}>
    {showContactPersons? <FontAwesomeIcon icon={faChevronUp} className='text-xs'/> : <FontAwesomeIcon icon={faChevronDown} className='text-xs'/>}
  </button>
  </div>
</div>
<div className={`${showContactPersons? '' : 'hidden'}`}>
  {Array.isArray(VendorContactPersons) && VendorContactPersons.length > 0 ? (
    VendorContactPersons.map((contactPerson) => (
      <div key={contactPerson._id} className='pt-4 pl-4 pr-4 flex flex-row'>
        <div className='w-[90%] flex flex-row'>
          <div className='w-2/5'>
            <img className=" rounded-md w-10 h-10 cursor-pointer" src={'/ProfileImageSvg.jpg'} alt="Brick Bucket Logo" />
          </div>
          <div className='w-4/5 text-sm ml-3 flex flex-col'>
            <div className='font-semibold mb-0.5 break-words word-break'>{contactPerson.name}</div>
            <div className='break-words word-break'>{contactPerson.email}</div>
            <div className='flex items-center'>
              <FontAwesomeIcon icon={faMobileAndroidAlt} className='mr-1 text-xs'/>
              <span className='break-words word-break'>{contactPerson.mobile_number}</span>
            </div>
            <div className='mb-0.5 break-words word-break'>{contactPerson.designation}</div>
          </div>
        </div>
        <div className='w-[5%]'></div>
        <div className=' w-[10%] flex justify-end'>
          <FontAwesomeIcon icon={faPen} onClick={() => handleEditContactPerson(contactPerson)} className='cursor-pointer hover:text-gray-500 text-gray-300 text-xs'/>
          <FontAwesomeIcon icon={faTrash} onClick={() => handleDeleteContactPerson(contactPerson)} className='cursor-pointer hover:text-gray-500 text-gray-300 text-xs ml-1'/>
        </div>
      </div>
    ))
  ) : (
    <div className='flex justify-center text-sm'>No contact persons found</div>
  )}
</div>
<div onClick={handleToggleBankAccountDetails}  className='pt-4 pl-4 pr-4 border-b flex flex-row justify-between items-center'>
  <div>
  <span className='text-sm cursor-pointer' onClick={handleToggleBankAccountDetails}>BANK ACCOUNT DETAILS</span>
  </div>
  <div>
  <button className='ml-2 text-gray-500 hover:text-gray-800 transition duration-300 ease-in-out' onClick={handleToggleBankAccountDetails}>
   {/*  <FontAwesomeIcon icon={faPlusCircle} onClick={handleBankPlusIconClick} className='text-blue-500 text-md'/> */}
  </button>
  <button className='ml-2 text-gray-500 hover:text-gray-800 transition duration-300 ease-in-out' onClick={handleToggleBankAccountDetails}>
    {ShowBankAccountDetails? <FontAwesomeIcon icon={faChevronUp} className='text-xs'/> : <FontAwesomeIcon icon={faChevronDown} className='text-xs'/>}
  </button>
  </div>
</div>
<div className={`${ShowBankAccountDetails ? '' : 'hidden'}`}>
  {selectedVendor.bank_name || selectedVendor.bank_branch || selectedVendor.bank_IFSC || selectedVendor.account_number || selectedVendor.account_holder_name ? (
    <div className='pt-4 pl-4 pr-4 flex flex-col'>
      <div className='flex items-center mb-4'>
        <div className='bg-blue-100 flex justify-center items-center p-2 rounded-md'>
          <FontAwesomeIcon icon={faBank} className='text-blue-500 text-md' />
        </div>
        <div className='flex flex-col ml-4'>
          <div className='font-semibold text-sm'>{selectedVendor.bank_name}</div>
          <div className='text-xs text-gray-600'>{selectedVendor.account_number}</div>
        </div>
      </div>
      <div className='flex flex-col'>
        <div className='flex mb-1 space-x-2'>
          <span className='w-20 text-xs font-normal text-gray-500'>IFSC Code</span>
          <span className='text-xs'>: {selectedVendor.bank_IFSC}</span>
        </div>
        <div className='flex mt-2 space-x-2'>
          <span className='w-20 text-xs font-normal text-gray-500'>Account Holder Name</span>
          <span className='text-xs'>: {selectedVendor.account_holder_name}</span>
        </div>
      </div>
    </div>
  ) : (
    <div className='flex justify-center text-sm'>No bank account details added yet</div>
  )}
</div>

<div className="bg-[#f2fff0] flex flex-col items-center border border-[#c6efce] mt-10 p-4 rounded mx-auto w-[220px] h-[140px]">
      <div className="text-black mb-4 text-sm flex justify-between space-x-4">
        <FontAwesomeIcon icon={faVcard} className="cursor-pointer text-[#7CB541] text-lg relative top-1" />
        <span>Vendor KYC has to be verified before approval in vendor</span>
      </div>
      <div className="flex justify-center items-center">
        {/* Show Disapprove if status is 3, otherwise show Approve */}
        {vendorApprovalStatus === 3 ? (
          <button
            className="bg-[#F5F5F5] border border-gray-400 text-black py-1 px-2 rounded text-sm"
            onClick={() => setShowDisapprovePopup(true)}
            disabled={loading}
          >
            Disapprove
          </button>
        ) : (
          <button
            className="bg-[#F5F5F5] border border-gray-400 text-black py-1 px-2 rounded text-sm"
            onClick={() => setShowApprovePopup(true)}
            disabled={loading}
          >
            Approve
          </button>
        )}
      </div>
    </div>   

  </div>
  <div className="w-[68%]  pl-2">
  <div className="w-full  ">
    <div className="flex flex-col justify-center items-center">
      <div className="flex flex-col justify-center items-center">
      {PurchaseOrders && PurchaseOrders.length > 0 ? (
          <div className="overflow-x-auto w-full container mx-auto px-4">
            <div className="p-2 flex justify-between items-center">
              <h1 className="text-md font-semibold">Purchase Orders</h1>
            </div>
            <table class="border-t border-b w-full">
              <thead>
                <tr className="text-[#212529] bg-[#fafafc]">                    
                  <th className="font-semibold text-xs py-2 px-4 border-b cursor-pointer" >
                    PO Number
                  </th>
                  <th className="font-semibold text-xs py-2 px-4 border-b cursor-pointer" >
                    Date
                  </th>
                  <th className="font-semibold text-xs py-2 px-4 border-b cursor-pointer" >
                    Status
                  </th>
                  <th className="font-semibold text-xs py-2 px-4 border-b cursor-pointer" >
                    Item category
                  </th>
                </tr>
              </thead>
              <tbody>
                {PurchaseOrders.map((po) => (
                  <tr key={po._id} className="text-xs  border-b">
                    <td className="py-2 text-center px-4 text-[#408dfb] font-500 cursor-pointer" onClick={() => handlenavigateToPurchaseOrderDetails(po)}>
                      {po?.purchaseorder_number}
                    </td>
                    <td className="py-2 text-center px-4">
                      {new Date(po?.purchaseorder_date).toLocaleDateString()}
                    </td>
                    <td className="py-2 text-center px-4">
                      {po?.purchaseorder_status}
                    </td>
                    <td className="py-2 text-center px-4">
                     {po?.product_category_id?.product_category_name}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-center text-gray-600">There are no Purchase Orders for this {selectedVendor?.name}.</p>
        )}
      </div>
    </div>
  </div>
</div>
</div>
</div>
                   

 {/* Popup starts */}

 {showVendorDetailsPopup && (
  <div className="fixed inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50 ">
  <div className="bg-white rounded-b-md shadow-md w-[550px] h-[300px] flex flex-col animate-slide-in" style={{ maxWidth: '550px', maxHeight: '300px' }}>
    <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-[18%] px-6'>
      <h2 className="text-md">Edit Vendor Details</h2>
      <button onClick={handleClosePopup} className="text-white px-1 py-1 rounded-md ">   
        <FontAwesomeIcon icon={faX} className="text-xs text-[#f7525a] cursor-pointer " />
      </button>
    </div>
    <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
    {vendorEditErrors.length > 0 && (
        <div className="flex justify-between items-center mt-1 mb-1 px-auto py-1 bg-[#fddcde] rounded-md">
          <div className="px-6 flex flex-col justify-start items-start">
            {vendorEditErrors.map((errorMessage, index) => (
              <span key={index} className="text-sm">• {errorMessage}</span>
            ))}
          </div>
          <div className='px-4'>
            <button className="text-gray-700 hover:text-red-500" onClick={() => setVendorEditErrors([])}>
              <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
            </button>
          </div>
        </div>
      )}
    <div className='p-20px mt-4 '>
    <div className="w-full flex flex-row items-center mb-4 space-x-6 px-6">
    <label htmlFor="name" className="block text-xs font-regular text-[#212529] w-1/6">
      Name
    </label>
    <input
      type="name"
      id="name"
      value={selectedVendor.name }
      onChange={handleVendorInputfieldChange}
      className="w-5/6 py-1 pl-2 pr-2 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-sm text-gray-700"
      placeholder="Enter Full Name"/>
  </div>

  <div className="w-full flex flex-row items-center mb-4 space-x-6 px-6">
    <label htmlFor="email" className="block text-xs font-regular text-[#212529] w-1/6">
      Email Address
    </label>
    <input
      type="email"
      value={selectedVendor.email}
      onChange={handleVendorInputfieldChange}
      id="email"
      className="w-5/6 py-1 pl-2 pr-2 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-sm text-gray-700"
      placeholder="Email Address"
    />
  </div>
  <div className="w-full flex flex-row items-center mb-4 space-x-5 px-6">
    <label htmlFor="Contact_info" className="block text-xs font-regular text-[#212529] w-1/6">
      Contact Info 
    </label>
    <input
      type="text"
      id="mobile_number"
      value={selectedVendor.mobile_number}
      onChange={handleVendorInputfieldChange}
      className="w-2/6 py-1 pl-2 pr-2 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-sm text-gray-700"
      placeholder="Mobile"
      pattern="\d{10}" 
            maxLength="10"
    />
  </div>    
</div>
    <div className="mt-auto w-full">
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      <div className="text-sm flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
      <button onClick={handleUpdateVendor}
        className="px-2 py-1 bg-[#f7525a]  border-[#f7525a] text-white rounded-md space-x-2 flex items-center">
  <span>Save</span>
  {isSaving && (<Spinner/>)}
</button>
        <button onClick={handleClosePopup} 
         className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
          isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
        }`}
        disabled={isSaving}>
          Cancel</button>
      </div>
    </div>
  </div>
</div>
)}

{showAddContactPersonPopup && (
  <div className="fixed inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50 ">
  <div className="bg-white rounded-b-md shadow-md w-[550px] h-[400px] flex flex-col animate-slide-in" style={{ maxWidth: '550px', maxHeight: '400px' }}>
    <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-14 px-6'>
    <h2 className="text-md">
    Add Contact Person
    </h2>
      <button onClick={handleClosePopup} className="text-white px-1 py-1 rounded-md ">   
        <FontAwesomeIcon icon={faX} className="text-xs text-[#212529] cursor-pointer " />
      </button>
    </div>
    <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
    <div className='p-20px '>
    {contactPersonErrors.length > 0 && (
        <div className="flex justify-between items-center mt-1 px-auto py-1 bg-[#fddcde] rounded-md">
          <div className="px-6 flex flex-col justify-start items-start">
            {contactPersonErrors.map((errorMessage, index) => (
              <span key={index} className="text-sm">• {errorMessage}</span>
            ))}
          </div>
          <div className='px-4'>
            <button className="text-gray-700 hover:text-red-500" onClick={() => setContactPersonErrors([])}>
              <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
            </button>
          </div>
        </div>
      )}  
      <div className="w-full flex flex-row items-center mb-4 space-x-6 mt-5 px-6">
    <label htmlFor="name" className="block text-xs font-regular text-[#212529] w-1/6">
      Name
    </label>
    <div className='w-5/6 flex justify-between'>
      <input
        type="text"
        id="name"
        value={newContactPerson.name}
        placeholder="Name"
        onChange={handleCreateContactPersonInputfieldChange }
        className="w-full py-1 pl-2 pr-2 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-sm text-gray-700"/>
    </div>
  </div>

  <div className="w-full flex flex-row items-center mb-4 space-x-6 px-6">
    <label htmlFor="email" className="block text-xs font-regular text-[#212529] w-1/6">
      Email Address
    </label>
    <input
      type="email"
      id="email"
      value={newContactPerson.email}
      onChange={handleCreateContactPersonInputfieldChange }
      className="w-5/6 py-1 pl-2 pr-2 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-sm text-gray-700"
      placeholder="Email Address"    />
  </div> 
  <div className="w-full flex flex-row items-center mb-4 space-x-6 px-6">
    <label htmlFor="Contact_info" className="block text-xs font-regular text-[#212529] w-1/6">
      Contact Info 
    </label>
    <input
      type="text"
      id="mobile_number"
      onChange={handleCreateContactPersonInputfieldChange }
      value={newContactPerson.mobile_number}
      className="w-2/6 py-1 pl-2 pr-2 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-sm text-gray-700"
      placeholder="Mobile"
      pattern="\d{10}" 
            maxLength="10"
    />
  </div>  
  <div className="w-full flex flex-row items-center mb-4 space-x-6 px-6">
    <label htmlFor="Other_details" className="block text-xs font-regular text-[#212529] w-1/6">
      Other Details 
    </label>
    <input
      type="text"
      id="designation"
      onChange={handleCreateContactPersonInputfieldChange }
      value={newContactPerson.designation}
      className="w-2/6 py-1 pl-2 pr-2 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-sm text-gray-700"
      placeholder="Designation" />
  </div>  
</div>
    <div className="mt-auto w-full">
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      <div className="text-sm flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
      <button className="px-2 py-1 bg-[#f7525a]  border-[#f7525a] text-white rounded-md space-x-2 flex items-center" onClick={handleCreateContactPerson}>
<span>Save</span>   {isSaving && (<Spinner/>)}
</button>
        <button onClick={handleClosePopup} 
         className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
          isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
        }`}
        disabled={isSaving}>
          Cancel</button>
      </div>
    </div>
  </div>
</div>
)}

{ShowEditContactPersonPopup && (
  <div className="fixed inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50 ">
  <div className="bg-white rounded-b-md shadow-md w-[550px] h-[400px] flex flex-col animate-slide-in" style={{ maxWidth: '550px', maxHeight: '400px' }}>
    <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-14 px-6'>
    <h2 className="text-md">
    Edit Contact Person
    </h2>
      <button onClick={handleClosePopup} className="text-white px-1 py-1 rounded-md ">   
        <FontAwesomeIcon icon={faX} className="text-xs text-[#212529] cursor-pointer " />
      </button>
    </div>
    <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
    <div className='p-20px '>
    {errorMessages.length > 0 && (
                <div className="flex justify-between items-center mt-1  px-auto py-1  bg-[#fddcde]  rounded-md">
                  <div className="px-6 flex flex-col justify-start items-start">
                    {errorMessages.map((errorMessage, index) => (
                      <span key={index} className="text-sm">
                         •   {errorMessage}
                      </span>
                    ))}
                  </div>
                  <div className='px-4'>
                  <button
                    className="text-gray-700 hover:text-red-500"
                    onClick={handleCloseError}
                  >
                    <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
                  </button>
                  </div>
                </div>
              )}
  <div className="w-full flex flex-row items-center mb-4 space-x-6 mt-5 px-6">
    <label htmlFor="name" className="block text-xs font-regular text-[#212529] w-1/6">
      Name
    </label>
    <div className='w-5/6 flex justify-between'>
      <input
        type="text"
        id="name"
        value={selectedContactPerson ? selectedContactPerson.name : ''}
        placeholder="Name"
        onChange={handleUpdateContactPersonInputfieldChange}
        className="w-full py-1 pl-2 pr-2 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-sm text-gray-700"/>
    </div>
  </div>

  <div className="w-full flex flex-row items-center mb-4 space-x-6 px-6">
    <label htmlFor="email" className="block text-xs font-regular text-[#212529] w-1/6">
      Email Address
    </label>
    <input
      type="email"
      id="email"
      value={selectedContactPerson ? selectedContactPerson.email : ''}
      onChange={handleUpdateContactPersonInputfieldChange}
      className="w-5/6 py-1 pl-2 pr-2 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-sm text-gray-700"
      placeholder="Email Address"    />
  </div> 
  <div className="w-full flex flex-row items-center mb-4 space-x-6 px-6">
    <label htmlFor="Contact_info" className="block text-xs font-regular text-[#212529] w-1/6">
      Contact Info 
    </label>
    <input
      type="text"
      id="mobile_number"
      onChange={handleUpdateContactPersonInputfieldChange}
      value={selectedContactPerson ? selectedContactPerson.mobile_number : ''}
      className="w-2/6 py-1 pl-2 pr-2 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-sm text-gray-700"
      placeholder="Mobile"
      pattern="\d{10}" 
            maxLength="10"
    />
  </div>  
  <div className="w-full flex flex-row items-center mb-4 space-x-6 px-6">
    <label htmlFor="Other_details" className="block text-xs font-regular text-[#212529] w-1/6">
      Other Details 
    </label>
    <input
      type="text"
      id="designation"
      onChange={handleUpdateContactPersonInputfieldChange}
      value={selectedContactPerson ? selectedContactPerson.designation : ''}
      className="w-2/6 py-1 pl-2 pr-2 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-sm text-gray-700"
      placeholder="Designation" />
  </div>  
</div>
    <div className="mt-auto w-full">
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      <div className="text-sm flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
      <button className="px-2 py-1 bg-[#f7525a]  border-[#f7525a] text-white rounded-md space-x-2 flex items-center" onClick={handleUpdateContactPerson}>
<span>Update</span>
{isSaving && (<Spinner/>)}
</button>
        <button onClick={handleClosePopup} 
         className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
          isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
        }`}
        disabled={isSaving}>
          Cancel</button>
      </div>
    </div>
  </div>
</div>
)}

{showAssignProductCategoryPopup && (
 <Assignvendor
  vendor={selectedVendor}
  categories={categories}
  subCategoryMap={subCategoryMap}
  onLoadSubCategories={fetchProductSubcategoriesByProductCategoryId}
   assignProductCategoriesToSelectedVendor={assignProductCategoriesToSelectedVendor}
   movData={movData}
    assignedCategories={vendorCategories}
     onClose={() => setShowAssignProductCategoryPopup(false)}

      onAfterSave={() =>
      fetchProductCategoriesOfSelectedVendor(selectedVendor._id)
    }
/>
)}


{showDiscountPopup && (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">


<div className="bg-white w-[900px] max-h-[90vh] flex flex-col rounded-xl shadow-xl">  
       <div className="px-6 py-4 border-b bg-gray-50">

  {/* First Line */}
  <h2 className="text-lg font-semibold text-gray-800">
    Set Discount Slabs
  </h2>

  {/* Second Line */}
  <div className="flex justify-between items-center">
   <span className="text-sm text-gray-600">
  Brand :{" "}
 <span className="font-medium text-blue-600">
  {selectedVendor?.name}
</span>
</span>

    <button
      onClick={() => setShowDiscountPopup(false)}
      className="text-gray-500 hover:text-red-500 hover:font-medium text-lg -mt-10"
    >
      ✕
    </button>
  </div>

</div>

      {/* Body */}
<div className="p-6 bg-white sticky top-0 z-20">
  {isDiscountLoading ? (
 <div className="flex justify-center items-center h-40">
    <div className="w-8 h-8 border-4 border-red-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
) : (
  <>

{/* PRODUCT CATEGORY */}
<div className="flex items-center mb-6">

  <label className="w-40 text-sm font-semibold text-gray-700">
    Product Category
  </label>

<select
  value={selectedCategory}
 onChange={(e) => {
  const value = e.target.value;

  // 🔥 SAVE CURRENT BEFORE RESET
  if (selectedVendor && selectedCategory && selectedSubCategory) {
    setSavedSlabs(prev => ({
      ...prev,
      [selectedVendor._id]: {
        ...prev[selectedVendor._id],
        [selectedCategory]: {
          ...prev[selectedVendor._id]?.[selectedCategory],
          [selectedSubCategory]: slabSections
        }
      }
    }));
  }

  setSelectedCategory(value);
  setSelectedSubCategory("");  

  // ✅ Reset slab sections (keep as is)
  setSlabSections([{
    id: Date.now(),
    rows: [getDefaultRow()]
  }]);

  setAttributes([]);
  setOpenDropdownIndex(null);

  if (value) {
    fetchAttributesByCategory(value, null);
    fetchProductSubcategoriesByProductCategoryId(value);
  }
}}
  className="w-64 border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none"
>
    <option value="">Select Category</option>

    {categories
      .filter(cat => vendorCategories.includes(cat._id))
      .map(cat => (
        <option key={cat._id} value={cat._id}>
          {cat.product_category_name}
        </option>
      ))}
  </select>

</div>

{/* PRODUCT SUBCATEGORY */}
<div className="flex items-center mb-6">

  <label className="w-40 text-sm font-semibold text-gray-700">
    Product Subcategory
  </label>

 <select
  value={selectedSubCategory}
 onChange={(e) => {
  const subId = e.target.value;

  // 🔥 SAVE CURRENT DATA
  if (selectedVendor && selectedCategory && selectedSubCategory) {
    setSavedSlabs(prev => ({
      ...prev,
      [selectedVendor._id]: {
        ...prev[selectedVendor._id],
        [selectedCategory]: {
          ...prev[selectedVendor._id]?.[selectedCategory],
          [selectedSubCategory]: slabSections
        }
      }
    }));
  }

  // ✅ FIRST set subcategory (keep as is)
  setSelectedSubCategory(subId);

  // 🔥 RESTORE if exists
  const restored =
    savedSlabs?.[selectedVendor._id]?.[selectedCategory]?.[subId];

  if (restored) {
    setSlabSections(restored);
  } else {
    // ✅ your original reset
    setSlabSections([{
      id: Date.now(),
      rows: [getDefaultRow()]
    }]);
  }

  setAttributes([]);
  setOpenDropdownIndex(null);

  fetchAttributesByCategory(selectedCategory, subId);
}}
  className="w-64 border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none"
>
  <option value="">Select Subcategory</option>

  {subCategories.map(sub => (
    <option key={sub._id} value={sub._id}>
      {/* Note: Check if your data uses subcategory_name or product_sub_category_name */}
      {sub.product_sub_category_name || sub.subcategory_name} 
    </option>
  ))}
</select>

</div>

<div className="flex justify-end mb-3">
  <button
    onClick={handleAddSlabSection}
    className="border border-gray-200 bg-gray-200 text-black px-4 py-2 rounded-md text-sm"
  >
    + Discount Slab
  </button>
</div>

<div className="max-h-[300px] overflow-y-auto pr-2 mb-8">


{slabSections.map((section, sectionIndex) => (
<div key={section.id} className="mb-2 border border-gray-300 rounded-md">
  {/* SINGLE BORDER CONTAINER */}
<div className="border border-gray-200 rounded-md overflow-visible">
    {/* HEADER */}
  <div className="px-4 py-2 border-b border-gray-200 flex items-center gap-2">

  {/* TEXT */}
  <h3 className="text-sm font-semibold text-gray-700">
     Discount Slab
  </h3>

  {/* DROPDOWN */}
  {/* DROPDOWN TRIGGER - FIXED INDEXING */}
<div 
  ref={(el) => (buttonRefs.current[sectionIndex] = el)}
  className="relative"
>
  <button
    type="button"
    onClick={(e) => {
      e.stopPropagation();
      
      // ✅ BULLETPROOF POSITIONING - Direct calculation, NO useEffect
      const button = buttonRefs.current[sectionIndex];
      if (button) {
        const rect = button.getBoundingClientRect();
        setDropdownStyle({
          top: rect.bottom + window.scrollY + 5,
          left: rect.left + window.scrollX
        });
      }
      
      // ✅ BULLETPROOF TOGGLE - Functional update prevents stale state
   setOpenDropdownIndex(prev =>
  prev === sectionIndex ? null : sectionIndex
);
    }}
    className="text-sm flex items-center gap-2 px-2 py-1 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
  >
    <FontAwesomeIcon 
      icon={faSliders} 
      className="text-gray-600 text-xs" 
    />
   <span className="text-xs font-medium">
  {slabSections[sectionIndex]?.rows?.some(row => row.attributes?.length > 0)
    ? `${[...new Map(
        slabSections[sectionIndex]?.rows
          ?.flatMap(row => row.attributes || [])
          .map(attr => [attr.id, attr])
      ).values()].length} attrs`
    : 'Select attrs'
  }
</span>
    {/* <FontAwesomeIcon 
  icon={faChevronDown} 
  className={`text-xs transition-transform ${
    openDropdownIndex?.sectionIndex === sectionIndex ? 'rotate-180' : ''
  }`} 
/> */}
  </button>
</div>

  {/* SELECTED ATTRIBUTES */}
{/* ✅ FIXED: Show ONLY VALUES (No Names) */}
<div className="flex gap-2 ml-auto items-center max-w-[550px] overflow-hidden">
  {(() => {
const targetSectionIndex = sectionIndex;
    const sectionRows = slabSections[targetSectionIndex]?.rows || [];
    
    // ✅ Get UNIQUE attribute VALUES only (no names)
    const allSectionValues = [
      ...new Map(
        sectionRows
          .flatMap(r => r.attributes || [])
          .map(a => [a.id, a.name])  // ✅ Use 'name' which is the VALUE
      ).values()
    ];

    return (
      <>
        {/* ✅ Show first 5 VALUES ONLY */}
        {allSectionValues.slice(0, 5).map((value, i) => (
          <span
            key={i}
            className="text-xs text-gray-700 bg-emerald-100 border border-emerald-200 px-2 py-0.5 rounded-md whitespace-nowrap"
          >
            {value}  {/* ✅ VALUE ONLY */}
          </span>
        ))}
        
        {/* ✅ +more count */}
        {allSectionValues.length > 5 && (
          <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded">
            +{allSectionValues.length - 5} more
          </span>
        )}
      </>
    );
  })()}
</div>

</div>
    {/* TABLE */}
<div className="">
          <table className="w-full border-collapse text-sm">

        {/* HEADER */}
      <thead className="bg-gray-100 sticky top-0 z-10">
          <tr>
            <th className="border px-4 py-2 w-12"></th>

            <th className="border px-4 py-2 text-center font-medium">
              Order Value
            </th>

            <th className="border px-3 py-2 text-center">
              <div className="flex flex-col items-center leading-tight">
                <span className="text-sm font-medium">
                  Discount
                </span>
              </div>
            </th>
          </tr>
        </thead>

        {/* BODY */}
        <tbody>
         {section.rows.map((row, rowIndex) => (
           <tr key={rowIndex}>
              
              {/* DELETE */}
              <td className="border px-2 py-2 text-center">
                <button
                 onClick={() => deleteRow(sectionIndex, rowIndex)}
                  className="text-gray-600 hover:text-red-600"
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </td>

              {/* MOV */}
              <td className="border px-2 py-4 text-center">
              <input
  type="text"
  placeholder="Order Value"
  value={row.mov}
  onChange={(e) => handleRowChange(sectionIndex, rowIndex, 'mov', e.target.value)}
  className="w-28 border rounded-md px-4 py-1 text-sm text-center"
/>

              </td>

              {/* ATTRIBUTE DISCOUNT */}
    <td className="border px-2 py-4 relative">
  <div className="flex justify-center">
    <div className="flex items-start gap-6 relative">

      <div className="relative">
      {/* <button
  type="button"
  ref={(el) => (buttonRefs.current[index] = el)}
  onClick={(e) => {
  e.stopPropagation();

  const rect = buttonRefs.current[index].getBoundingClientRect();

  setDropdownStyle({
    top: rect.bottom + window.scrollY,
    left: rect.left + window.scrollX
  });

  setOpenDropdownIndex((prev) =>
    prev === index ? null : index 
  );
}}


          className="border px-3 py-1 rounded-md text-sm bg-white flex items-center gap-2"
        >
          <span>Select Attributes</span>

          <svg
            className={`w-4 h-4 transition-transform duration-200 ${
              row.open ? "rotate-180" : ""
            }`}
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button> */}

        {/* {row.open && (
<div className="absolute left-0 top-full z-[9999] mt-1 bg-white border rounded-md shadow-lg p-2 w-40 max-h-60 overflow-y-auto">            {attributes.length === 0 && (
              <p className="text-sm text-gray-400">No attributes</p>
            )}

            {attributes.map((attr) => (
              <label
                key={attr.attribute_name_id}
                className="flex items-center gap-2 text-sm"
              >
                <input
                  type="checkbox"
                  checked={row.attributes?.some(
                    (a) => a.id === attr.attribute_name_id
                  )}
                  onChange={() => {
                    const updatedRows = [...rows];
                    const currentAttrs = row.attributes || [];

                    if (
                      currentAttrs.some(
                        (a) => a.id === attr.attribute_name_id
                      )
                    ) {
                      updatedRows[index].attributes = currentAttrs.filter(
                        (a) => a.id !== attr.attribute_name_id
                      );
                    } else {
                      updatedRows[index].attributes = [
                        ...currentAttrs,
                        {
                          id: attr.attribute_name_id,
                          name: attr.attribute_name
                        }
                      ];
                    }

                    setRows(updatedRows);
                  }}
                />

                {attr.attribute_name}
              </label>
            ))}
          </div>
        )} */}
      </div>

      {/* RIGHT SIDE */}
      <div className="flex flex-col gap-2">

        {/* ✅ Selected Attributes (NO individual discount) */}
       {/* <div className="flex gap-2 items-center max-w-[350px] overflow-hidden">
  {(row.attributes || []).slice(0, 3).map((attrObj, i) => (
    <span
      key={i}
      className="text-sm text-gray-600 bg-gray-100 px-2 py-1 rounded whitespace-nowrap"
    >
      {attrObj.name}
    </span>
  ))}

  {(row.attributes?.length > 3) && (
    <span className="text-xs text-gray-500">
      +{row.attributes.length - 3} more
    </span>
  )}
</div> */}

        {/* ✅ SINGLE DISCOUNT FIELD */}
{/* {(row.attributes && row.attributes.length > 0) && ( */}
  <input
    type="text"
    placeholder="%"
    value={row.discount || ""}
   onChange={(e) => handleRowChange(sectionIndex, rowIndex, 'discount', e.target.value)}
    className="w-24 border rounded-md px-3 py-1 text-sm text-center"
  />

      </div>

    </div>
  </div>
</td>



            </tr>
          ))}
        </tbody>

      </table>
    </div>

  </div>


  {/* ADD ROW */}
 <button
  onClick={() => addRow(sectionIndex)}
  className="text-blue-500 mt-2 mb-2 ml-2 px-3 py-1 rounded-md text-sm font-medium"
>
  + Add Row
</button>
</div>
))}

</div>


      {/* Footer */}
        <div className="px-4 py-3 border-t flex justify-end gap-2 bottom-0 sticky pb-0">
        <button
          onClick={() => setShowDiscountPopup(false)}
          className="px-4 py-1 border rounded"
        >
          Cancel
        </button>

       <button
  onClick={handleSaveDiscountSlabs}
  className="px-4 py-1 bg-blue-600 text-white rounded"
>
  Save Changes
</button>
      </div>
 </>
  )}
</div>
    </div>
  </div>
)}

{/* {showAssignProductCategoryPopup && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
    <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl flex flex-col animate-scale-in">
      <div className='flex justify-between items-center px-6 py-3 border-b border-gray-200'>
        <div>
          <h2 className="text-base font-semibold text-gray-900">Assign Categories to Vendor</h2>
          <p className="text-xs text-gray-600 mt-1">Vendor: <span className="font-medium text-blue-600">{selectedVendor.name}</span></p>
        </div>
        <button 
          onClick={handleClosePopup}
          className="w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
        >
          <FontAwesomeIcon icon={faX} className="text-gray-600 text-xs" />
        </button>
      </div>

      <div className="p-4">
        <p className="text-xs text-gray-600 mb-3">Select the product categories this vendor can supply:</p>
        
        <div className="max-h-80 overflow-y-auto pr-1">
          <div className="grid grid-cols-4 gap-2">
            {categories.map((category) => (
              <div 
                key={category._id}
                className={`
                  flex items-start p-2 rounded-md border transition-all cursor-pointer min-h-[60px]
                  ${vendorCategories.includes(category._id)
                    ? 'bg-blue-50 border-blue-200'
                    : 'bg-white border-gray-200 hover:bg-gray-50'
                  }
                `}
                onClick={() => handleCategoryChange(category._id)}
              >
                <input
                  type="checkbox"
                  id={category._id}
                  checked={vendorCategories.includes(category._id) || false}
                  onChange={() => handleCategoryChange(category._id)}
                  className="mt-0.5 h-3 w-3 text-blue-600 focus:ring-blue-500 border-gray-300 rounded flex-shrink-0"
                />
                <label 
                  htmlFor={category._id}
                  className="ml-2 text-xs text-gray-900 cursor-pointer break-words whitespace-normal leading-tight"
                >
                  {category.product_category_name}
                </label>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-4 pt-3 border-t border-gray-200">
          <p className="text-xs text-gray-600">
            <span className="font-semibold text-blue-600">{vendorCategories.length}</span> of {categories.length} categories selected
          </p>
        </div>
      </div>

      <div className="px-4 py-3 border-t border-gray-200 bg-gray-50 rounded-b-lg">
        <div className="flex justify-end space-x-2">
          <button 
            onClick={handleClosePopup}
            className="px-4 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button 
            onClick={assignProductCategoriesToSelectedVendor}
            disabled={isSaving || vendorCategories.length === 0}
            className={`
              px-4 py-1.5 text-xs font-medium text-white rounded-md transition-colors flex items-center space-x-1
              ${isSaving || vendorCategories.length === 0
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-blue-600 hover:bg-blue-700'
              }
            `}
          >
            {isSaving ? (
              <>
                <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin" />
                <span>Saving...</span>
              </>
            ) : (
              <span>Save Changes</span>
            )}
          </button>
        </div>
      </div>
    </div>
  </div>
)} */}

{ShowDeleteContactPersonPopup && (
  <div className="fixed inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50 ">
  <div className="bg-white rounded-b-md shadow-md w-[550px] h-[150px] flex flex-col animate-slide-in" style={{ maxWidth: '550px', maxHeight: '150px' }}>
    <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
    <div className='pt-4 pl-4 '>
  <div className="w-full items-center p-5">
    <label htmlFor="Other_details" className="block text-sm font-regular text-[#212529] ">
    Do you want to delete the contact person?
    </label>
  </div>  
</div>
    <div className="mt-auto w-full">
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      <div className="text-sm flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
      <button className="px-2 py-1 bg-[#f7525a]  text-white rounded-md space-x-2 flex items-center" onClick={handleConfirmDelete}>
<span>Delete</span>  {isSaving && (
    <Spinner/>
  )}
</button>
        <button onClick={handleClosePopup} 
        className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
          isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
        }`}
        disabled={isSaving}>
          Cancel</button>
      </div>
    </div>
  </div>
</div>
)}

{showApprovePopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg w-80">
      <h2 className="text-lg font-semibold mb-4 text-center">Approve Vendor?</h2>
      <p className="text-sm text-gray-600 mb-6 text-center">
        Are you sure you want to approve this vendor?
      </p>

      <div className="flex justify-center gap-4">
        <button
          className="px-4 py-1 bg-gray-200 rounded"
          onClick={() => setShowApprovePopup(false)}
        >
          Cancel
        </button>

        <button
          className="px-4 py-1 bg-green-600 text-white rounded"
          onClick={() => {
            setShowApprovePopup(false);
            handleApprove();
          }}
        >
          Yes, Approve
        </button>
      </div>
    </div>
  </div>
)}
{showDisapprovePopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg w-80">
      <h2 className="text-lg font-semibold mb-4 text-center">Disapprove Vendor?</h2>
      <p className="text-sm text-gray-600 mb-6 text-center">
        Are you sure you want to disapprove this vendor?
      </p>

      <div className="flex justify-center gap-4">
        <button
          className="px-4 py-1 bg-gray-200 rounded"
          onClick={() => setShowDisapprovePopup(false)}
        >
          Cancel
        </button>

        <button
          className="px-4 py-1 bg-red-600 text-white rounded"
          onClick={() => {
            setShowDisapprovePopup(false);
            handleDisapprove();
          }}
        >
          Yes, Disapprove
        </button>
      </div>
    </div>
  </div>
)}

{deleteConfirmed.show && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div className="bg-white rounded-lg p-5 w-[300px] shadow-lg">
      
      <h3 className="text-md font-semibold mb-3">
        Confirm Delete
      </h3>

      <p className="text-sm text-gray-600 mb-4">
        Are you sure you want to delete this discount slab?
      </p>

      <div className="flex justify-end gap-2">
        <button
          onClick={() => setDeleteConfirmed({ show: false, index: null })}
          className="px-3 py-1 border rounded"
        >
          Cancel
        </button>

        <button
          onClick={handleConfirmedDelete}
          className="px-3 py-1 bg-red-600 text-white rounded"
        >
          Delete
        </button>
      </div>

    </div>
  </div>
)}

{/* 🔥 CLEANEST VERSION - No header, no extra text */}
{openDropdownIndex?.sectionIndex !== null && attributes.length > 0 && (
  <div
className="fixed z-[9999] w-56 max-h-72 bg-white overflow-y-auto"    style={dropdownStyle}
    onClick={(e) => e.stopPropagation()}
  >
    {(() => {
const targetSectionIndex = openDropdownIndex;      
      if (targetSectionIndex === null || 
          targetSectionIndex >= slabSections.length || 
          !slabSections[targetSectionIndex]) {
        return null;
      }

const filteredAttributes = attributes.filter(attr =>
  !selectedSubCategory || 
  String(attr.product_sub_category_id) === String(selectedSubCategory)
);
if (filteredAttributes.length === 0) {
  return (
    <div className="p-2 text-sm text-gray-400">
      No attributes
    </div>
  );
}

      return filteredAttributes.flatMap((attr) =>
        (attr.attribute_values || [])
          .filter(val => val.attribute_value && val.attribute_value.trim() !== '')
          .map((val) => (
            <label
              key={val.attribute_value_id}
className="flex items-center gap-3 px-2 py-1 hover:bg-blue-50 cursor-pointer border-b border-gray-100"            >
              <input
                type="checkbox"
                className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 flex-shrink-0"
                checked={
                  slabSections[targetSectionIndex]?.rows?.some(row => 
                    row.attributes?.some(a => a.id === val.attribute_value_id)
                  ) || false
                }
         onChange={() => {
  setSlabSections(prevSections =>
    prevSections.map((section, sIndex) =>
      sIndex === targetSectionIndex
        ? {
            ...section,
            rows: section.rows.map((row) =>  // ✅ REMOVED rIndex CONDITION
              (() => {
                const currentAttrs = row.attributes || [];

                let updatedAttrs;

                if (currentAttrs.some(a => a.id === val.attribute_value_id)) {
                  updatedAttrs = currentAttrs.filter(
                    a => a.id !== val.attribute_value_id
                  );
                } else {
                  updatedAttrs = [
                    ...currentAttrs,
                    {
                      id: val.attribute_value_id,
                      name: val.attribute_value
                    }
                  ];
                }

                return {
                  ...row,
                  attributes: updatedAttrs,
                  attributeIds: updatedAttrs.map(a => a.id) // ✅ IMPORTANT FIX
                };
              })()
            )
          }
        : section
    )
  );
}}
              />
              {/* ✅ ONLY VALUE - NO ATTRIBUTE NAME */}
              <div className="flex-1 min-w-0">
                <span className="text-sm font-medium text-gray-900 truncate block">
                  {val.attribute_value}  {/* ✅ Value only */}
                </span>
                {/* ✅ REMOVED: attr.attribute_name */}
              </div>
            </label>
          ))
      );
    })()}
  </div>
)}

{showPopup && (
  <div className="z-[9999]">
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
    {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
    {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
    {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
  </div>
)}
{/* Popup ends */}

    </div>
  );
};
export default ViewVendor;